// GENERATED FILE – DO NOT EDIT BY HAND.
// Source: specs/project-requirements via @pericles/generator v0.
// Generated by pericles-gen generate-ui-app-v0.
import type { UiAppSpec } from '@pericles/framework-frontend';

export const appUiSpec: UiAppSpec = {
  "appName": "Project Requirements",
  "nav": [
    {
      "id": "main",
      "label": "Project Requirements",
      "items": [
        {
          "id": "customers_list",
          "label": "Customers",
          "route": "/customers_list",
          "entityId": "Customer",
          "screenId": "customers_list"
        },
        {
          "id": "projects_list",
          "label": "Projects",
          "route": "/projects_list",
          "entityId": "Project",
          "screenId": "projects_list"
        },
        {
          "id": "requirements_list",
          "label": "Requirements",
          "route": "/requirements_list",
          "entityId": "Requirement",
          "screenId": "requirements_list"
        },
        {
          "id": "requirements_to_review_list",
          "label": "Requirements to Review",
          "route": "/requirements_to_review_list",
          "entityId": "Requirement",
          "screenId": "requirements_to_review_list"
        },
        {
          "id": "requirements_to_generate_list",
          "label": "Requirements to Generate",
          "route": "/requirements_to_generate_list",
          "entityId": "Requirement",
          "screenId": "requirements_to_generate_list"
        },
        {
          "id": "spec_sections_list",
          "label": "Spec Sections",
          "route": "/spec_sections_list",
          "entityId": "SpecSection",
          "screenId": "spec_sections_list"
        },
        {
          "id": "work_items_list",
          "label": "Work Items",
          "route": "/work_items_list",
          "entityId": "WorkItem",
          "screenId": "work_items_list"
        },
        {
          "id": "project_meetings_list",
          "label": "Project Meetings",
          "route": "/project_meetings_list",
          "entityId": "ProjectMeeting",
          "screenId": "project_meetings_list"
        },
        {
          "id": "checklist_items_list",
          "label": "Checklist Items",
          "route": "/checklist_items_list",
          "entityId": "ChecklistItem",
          "screenId": "checklist_items_list"
        }
      ]
    }
  ],
  "entities": [
    {
      "id": "tenant",
      "entityName": "Tenant",
      "label": "Tenant",
      "form": {
        "entity": "Tenant",
        "create": {
          "title": "Create Tenant",
          "sections": [
            {
              "id": "Tenant-main",
              "title": "Tenant fields",
              "fields": [
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "slug",
                  "label": "Slug",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "rbacEnabled",
                  "label": "RbacEnabled",
                  "editor": "checkbox",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit Tenant",
          "sections": [
            {
              "id": "Tenant-main",
              "title": "Tenant fields",
              "fields": [
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "slug",
                  "label": "Slug",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "rbacEnabled",
                  "label": "RbacEnabled",
                  "editor": "checkbox",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "user",
      "entityName": "User",
      "label": "User",
      "form": {
        "entity": "User",
        "create": {
          "title": "Create User",
          "sections": [
            {
              "id": "User-main",
              "title": "User fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "email",
                  "label": "Email",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "firstName",
                  "label": "FirstName",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "lastName",
                  "label": "LastName",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "department",
                  "label": "Department",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "passwordHash",
                  "label": "PasswordHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "passwordResetTokenHash",
                  "label": "PasswordResetTokenHash",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "passwordResetTokenExpiresAt",
                  "label": "PasswordResetTokenExpiresAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "OWNER",
                      "label": "OWNER"
                    },
                    {
                      "value": "USER",
                      "label": "USER"
                    }
                  ]
                },
                {
                  "field": "firmRole",
                  "label": "FirmRole",
                  "editor": "select",
                  "required": false,
                  "options": [
                    {
                      "value": "PARTNER",
                      "label": "PARTNER"
                    },
                    {
                      "value": "PRINCIPAL",
                      "label": "PRINCIPAL"
                    },
                    {
                      "value": "MANAGER",
                      "label": "MANAGER"
                    },
                    {
                      "value": "CONSULTANT",
                      "label": "CONSULTANT"
                    },
                    {
                      "value": "ANALYST",
                      "label": "ANALYST"
                    },
                    {
                      "value": "INTERN",
                      "label": "INTERN"
                    },
                    {
                      "value": "STAFF",
                      "label": "STAFF"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit User",
          "sections": [
            {
              "id": "User-main",
              "title": "User fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "email",
                  "label": "Email",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "firstName",
                  "label": "FirstName",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "lastName",
                  "label": "LastName",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "department",
                  "label": "Department",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "passwordHash",
                  "label": "PasswordHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "passwordResetTokenHash",
                  "label": "PasswordResetTokenHash",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "passwordResetTokenExpiresAt",
                  "label": "PasswordResetTokenExpiresAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "OWNER",
                      "label": "OWNER"
                    },
                    {
                      "value": "USER",
                      "label": "USER"
                    }
                  ]
                },
                {
                  "field": "firmRole",
                  "label": "FirmRole",
                  "editor": "select",
                  "required": false,
                  "options": [
                    {
                      "value": "PARTNER",
                      "label": "PARTNER"
                    },
                    {
                      "value": "PRINCIPAL",
                      "label": "PRINCIPAL"
                    },
                    {
                      "value": "MANAGER",
                      "label": "MANAGER"
                    },
                    {
                      "value": "CONSULTANT",
                      "label": "CONSULTANT"
                    },
                    {
                      "value": "ANALYST",
                      "label": "ANALYST"
                    },
                    {
                      "value": "INTERN",
                      "label": "INTERN"
                    },
                    {
                      "value": "STAFF",
                      "label": "STAFF"
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "session",
      "entityName": "Session",
      "label": "Session",
      "form": {
        "entity": "Session",
        "create": {
          "title": "Create Session",
          "sections": [
            {
              "id": "Session-main",
              "title": "Session fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tokenHash",
                  "label": "TokenHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "expiresAt",
                  "label": "ExpiresAt",
                  "editor": "date",
                  "required": true,
                  "options": []
                },
                {
                  "field": "lastSeenAt",
                  "label": "LastSeenAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "invalidatedAt",
                  "label": "InvalidatedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "invalidationReason",
                  "label": "InvalidationReason",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "replacedBySessionId",
                  "label": "ReplacedBySessionId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "rotatedAt",
                  "label": "RotatedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit Session",
          "sections": [
            {
              "id": "Session-main",
              "title": "Session fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tokenHash",
                  "label": "TokenHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "expiresAt",
                  "label": "ExpiresAt",
                  "editor": "date",
                  "required": true,
                  "options": []
                },
                {
                  "field": "lastSeenAt",
                  "label": "LastSeenAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "invalidatedAt",
                  "label": "InvalidatedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "invalidationReason",
                  "label": "InvalidationReason",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "replacedBySessionId",
                  "label": "ReplacedBySessionId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "rotatedAt",
                  "label": "RotatedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "auth-audit-event",
      "entityName": "AuthAuditEvent",
      "label": "AuthAuditEvent",
      "form": {
        "entity": "AuthAuditEvent",
        "create": {
          "title": "Create AuthAuditEvent",
          "sections": [
            {
              "id": "AuthAuditEvent-main",
              "title": "AuthAuditEvent fields",
              "fields": [
                {
                  "field": "eventType",
                  "label": "EventType",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "ipAddress",
                  "label": "IpAddress",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "metadata",
                  "label": "Metadata",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reason",
                  "label": "Reason",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sessionId",
                  "label": "SessionId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": false,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "userAgent",
                  "label": "UserAgent",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit AuthAuditEvent",
          "sections": [
            {
              "id": "AuthAuditEvent-main",
              "title": "AuthAuditEvent fields",
              "fields": [
                {
                  "field": "eventType",
                  "label": "EventType",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "ipAddress",
                  "label": "IpAddress",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "metadata",
                  "label": "Metadata",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reason",
                  "label": "Reason",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sessionId",
                  "label": "SessionId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": false,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "userAgent",
                  "label": "UserAgent",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "rbac-role",
      "entityName": "RbacRole",
      "label": "RbacRole",
      "form": {
        "entity": "RbacRole",
        "create": {
          "title": "Create RbacRole",
          "sections": [
            {
              "id": "RbacRole-main",
              "title": "RbacRole fields",
              "fields": [
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RbacRole",
          "sections": [
            {
              "id": "RbacRole-main",
              "title": "RbacRole fields",
              "fields": [
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "rbac-permission",
      "entityName": "RbacPermission",
      "label": "RbacPermission",
      "form": {
        "entity": "RbacPermission",
        "create": {
          "title": "Create RbacPermission",
          "sections": [
            {
              "id": "RbacPermission-main",
              "title": "RbacPermission fields",
              "fields": [
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "key",
                  "label": "Key",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RbacPermission",
          "sections": [
            {
              "id": "RbacPermission-main",
              "title": "RbacPermission fields",
              "fields": [
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "key",
                  "label": "Key",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "rbac-role-permission",
      "entityName": "RbacRolePermission",
      "label": "RbacRolePermission",
      "form": {
        "entity": "RbacRolePermission",
        "create": {
          "title": "Create RbacRolePermission",
          "sections": [
            {
              "id": "RbacRolePermission-main",
              "title": "RbacRolePermission fields",
              "fields": [
                {
                  "field": "permission",
                  "label": "Permission",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "permissionId",
                  "label": "PermissionId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "roleId",
                  "label": "RoleId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RbacRolePermission",
          "sections": [
            {
              "id": "RbacRolePermission-main",
              "title": "RbacRolePermission fields",
              "fields": [
                {
                  "field": "permission",
                  "label": "Permission",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "permissionId",
                  "label": "PermissionId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "roleId",
                  "label": "RoleId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "rbac-user-role",
      "entityName": "RbacUserRole",
      "label": "RbacUserRole",
      "form": {
        "entity": "RbacUserRole",
        "create": {
          "title": "Create RbacUserRole",
          "sections": [
            {
              "id": "RbacUserRole-main",
              "title": "RbacUserRole fields",
              "fields": [
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "roleId",
                  "label": "RoleId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RbacUserRole",
          "sections": [
            {
              "id": "RbacUserRole-main",
              "title": "RbacUserRole fields",
              "fields": [
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "roleId",
                  "label": "RoleId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "template-import",
      "entityName": "TemplateImport",
      "label": "TemplateImport",
      "form": {
        "entity": "TemplateImport",
        "create": {
          "title": "Create TemplateImport",
          "sections": [
            {
              "id": "TemplateImport-main",
              "title": "TemplateImport fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "templateId",
                  "label": "TemplateId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "version",
                  "label": "Version",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "importedAt",
                  "label": "ImportedAt",
                  "editor": "date",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit TemplateImport",
          "sections": [
            {
              "id": "TemplateImport-main",
              "title": "TemplateImport fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "templateId",
                  "label": "TemplateId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "version",
                  "label": "Version",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "importedAt",
                  "label": "ImportedAt",
                  "editor": "date",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-project",
      "entityName": "RoadmapProject",
      "label": "RoadmapProject",
      "form": {
        "entity": "RoadmapProject",
        "create": {
          "title": "Create RoadmapProject",
          "sections": [
            {
              "id": "RoadmapProject-main",
              "title": "RoadmapProject fields",
              "fields": [
                {
                  "field": "customer",
                  "label": "Customer",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customerId",
                  "label": "CustomerId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "reviewGroups",
                  "label": "ReviewGroups",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewImpactAxes",
                  "label": "ReviewImpactAxes",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewRaw",
                  "label": "ReviewRaw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewSummary",
                  "label": "ReviewSummary",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewUpdatedAt",
                  "label": "ReviewUpdatedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "firstReviewValidatedAt",
                  "label": "FirstReviewValidatedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "firstReviewValidatedByUserId",
                  "label": "FirstReviewValidatedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "firstReviewForceValidated",
                  "label": "FirstReviewForceValidated",
                  "editor": "checkbox",
                  "required": true,
                  "options": []
                },
                {
                  "field": "firstReviewValidationNotes",
                  "label": "FirstReviewValidationNotes",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapProject",
          "sections": [
            {
              "id": "RoadmapProject-main",
              "title": "RoadmapProject fields",
              "fields": [
                {
                  "field": "customer",
                  "label": "Customer",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customerId",
                  "label": "CustomerId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "reviewGroups",
                  "label": "ReviewGroups",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewImpactAxes",
                  "label": "ReviewImpactAxes",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewRaw",
                  "label": "ReviewRaw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewSummary",
                  "label": "ReviewSummary",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewUpdatedAt",
                  "label": "ReviewUpdatedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "firstReviewValidatedAt",
                  "label": "FirstReviewValidatedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "firstReviewValidatedByUserId",
                  "label": "FirstReviewValidatedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "firstReviewForceValidated",
                  "label": "FirstReviewForceValidated",
                  "editor": "checkbox",
                  "required": true,
                  "options": []
                },
                {
                  "field": "firstReviewValidationNotes",
                  "label": "FirstReviewValidationNotes",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-project-analysis-fields",
      "entityName": "RoadmapProjectAnalysisFields",
      "label": "RoadmapProjectAnalysisFields",
      "form": {
        "entity": "RoadmapProjectAnalysisFields",
        "create": {
          "title": "Create RoadmapProjectAnalysisFields",
          "sections": [
            {
              "id": "RoadmapProjectAnalysisFields-main",
              "title": "RoadmapProjectAnalysisFields fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "processFields",
                  "label": "ProcessFields",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCaseFields",
                  "label": "UseCaseFields",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "includeRawFields",
                  "label": "IncludeRawFields",
                  "editor": "checkbox",
                  "required": true,
                  "options": []
                },
                {
                  "field": "processRawFields",
                  "label": "ProcessRawFields",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "useCaseRawFields",
                  "label": "UseCaseRawFields",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapProjectAnalysisFields",
          "sections": [
            {
              "id": "RoadmapProjectAnalysisFields-main",
              "title": "RoadmapProjectAnalysisFields fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "processFields",
                  "label": "ProcessFields",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCaseFields",
                  "label": "UseCaseFields",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "includeRawFields",
                  "label": "IncludeRawFields",
                  "editor": "checkbox",
                  "required": true,
                  "options": []
                },
                {
                  "field": "processRawFields",
                  "label": "ProcessRawFields",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "useCaseRawFields",
                  "label": "UseCaseRawFields",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-quality-audit-report",
      "entityName": "RoadmapQualityAuditReport",
      "label": "RoadmapQualityAuditReport",
      "form": {
        "entity": "RoadmapQualityAuditReport",
        "create": {
          "title": "Create RoadmapQualityAuditReport",
          "sections": [
            {
              "id": "RoadmapQualityAuditReport-main",
              "title": "RoadmapQualityAuditReport fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "inputsHash",
                  "label": "InputsHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "stopReason",
                  "label": "StopReason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "report",
                  "label": "Report",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "evidenceManifest",
                  "label": "EvidenceManifest",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapQualityAuditReport",
          "sections": [
            {
              "id": "RoadmapQualityAuditReport-main",
              "title": "RoadmapQualityAuditReport fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "inputsHash",
                  "label": "InputsHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "stopReason",
                  "label": "StopReason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "report",
                  "label": "Report",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "evidenceManifest",
                  "label": "EvidenceManifest",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-quality-gate-override",
      "entityName": "RoadmapQualityGateOverride",
      "label": "RoadmapQualityGateOverride",
      "form": {
        "entity": "RoadmapQualityGateOverride",
        "create": {
          "title": "Create RoadmapQualityGateOverride",
          "sections": [
            {
              "id": "RoadmapQualityGateOverride-main",
              "title": "RoadmapQualityGateOverride fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "report",
                  "label": "Report",
                  "editor": "select",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reportId",
                  "label": "ReportId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reason",
                  "label": "Reason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "snapshotJson",
                  "label": "SnapshotJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "forcePass",
                  "label": "ForcePass",
                  "editor": "checkbox",
                  "required": true,
                  "options": []
                },
                {
                  "field": "createdByUserId",
                  "label": "CreatedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapQualityGateOverride",
          "sections": [
            {
              "id": "RoadmapQualityGateOverride-main",
              "title": "RoadmapQualityGateOverride fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "report",
                  "label": "Report",
                  "editor": "select",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reportId",
                  "label": "ReportId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reason",
                  "label": "Reason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "snapshotJson",
                  "label": "SnapshotJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "forcePass",
                  "label": "ForcePass",
                  "editor": "checkbox",
                  "required": true,
                  "options": []
                },
                {
                  "field": "createdByUserId",
                  "label": "CreatedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-review-field-config",
      "entityName": "RoadmapReviewFieldConfig",
      "label": "RoadmapReviewFieldConfig",
      "form": {
        "entity": "RoadmapReviewFieldConfig",
        "create": {
          "title": "Create RoadmapReviewFieldConfig",
          "sections": [
            {
              "id": "RoadmapReviewFieldConfig-main",
              "title": "RoadmapReviewFieldConfig fields",
              "fields": [
                {
                  "field": "scope",
                  "label": "Scope",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "fieldsOrder",
                  "label": "FieldsOrder",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "enabledFields",
                  "label": "EnabledFields",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "updatedByUserId",
                  "label": "UpdatedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapReviewFieldConfig",
          "sections": [
            {
              "id": "RoadmapReviewFieldConfig-main",
              "title": "RoadmapReviewFieldConfig fields",
              "fields": [
                {
                  "field": "scope",
                  "label": "Scope",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "fieldsOrder",
                  "label": "FieldsOrder",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "enabledFields",
                  "label": "EnabledFields",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "updatedByUserId",
                  "label": "UpdatedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-scoring-role-member",
      "entityName": "RoadmapScoringRoleMember",
      "label": "RoadmapScoringRoleMember",
      "form": {
        "entity": "RoadmapScoringRoleMember",
        "create": {
          "title": "Create RoadmapScoringRoleMember",
          "sections": [
            {
              "id": "RoadmapScoringRoleMember-main",
              "title": "RoadmapScoringRoleMember fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "scoringRole",
                  "label": "ScoringRole",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "createdByUserId",
                  "label": "CreatedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapScoringRoleMember",
          "sections": [
            {
              "id": "RoadmapScoringRoleMember-main",
              "title": "RoadmapScoringRoleMember fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "scoringRole",
                  "label": "ScoringRole",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "createdByUserId",
                  "label": "CreatedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-project-synthesis",
      "entityName": "RoadmapProjectSynthesis",
      "label": "RoadmapProjectSynthesis",
      "form": {
        "entity": "RoadmapProjectSynthesis",
        "create": {
          "title": "Create RoadmapProjectSynthesis",
          "sections": [
            {
              "id": "RoadmapProjectSynthesis-main",
              "title": "RoadmapProjectSynthesis fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "inputsHash",
                  "label": "InputsHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "stopReason",
                  "label": "StopReason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "synthesis",
                  "label": "Synthesis",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "evidenceManifest",
                  "label": "EvidenceManifest",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapProjectSynthesis",
          "sections": [
            {
              "id": "RoadmapProjectSynthesis-main",
              "title": "RoadmapProjectSynthesis fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "inputsHash",
                  "label": "InputsHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "stopReason",
                  "label": "StopReason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "synthesis",
                  "label": "Synthesis",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "evidenceManifest",
                  "label": "EvidenceManifest",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-airtable-settings",
      "entityName": "RoadmapAirtableSettings",
      "label": "RoadmapAirtableSettings",
      "form": {
        "entity": "RoadmapAirtableSettings",
        "create": {
          "title": "Create RoadmapAirtableSettings",
          "sections": [
            {
              "id": "RoadmapAirtableSettings-main",
              "title": "RoadmapAirtableSettings fields",
              "fields": [
                {
                  "field": "baseId",
                  "label": "BaseId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "apiToken",
                  "label": "ApiToken",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "processesTable",
                  "label": "ProcessesTable",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "processesView",
                  "label": "ProcessesView",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "useCasesTable",
                  "label": "UseCasesTable",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCasesView",
                  "label": "UseCasesView",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapAirtableSettings",
          "sections": [
            {
              "id": "RoadmapAirtableSettings-main",
              "title": "RoadmapAirtableSettings fields",
              "fields": [
                {
                  "field": "baseId",
                  "label": "BaseId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "apiToken",
                  "label": "ApiToken",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "processesTable",
                  "label": "ProcessesTable",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "processesView",
                  "label": "ProcessesView",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "useCasesTable",
                  "label": "UseCasesTable",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCasesView",
                  "label": "UseCasesView",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-process",
      "entityName": "RoadmapProcess",
      "label": "RoadmapProcess",
      "form": {
        "entity": "RoadmapProcess",
        "create": {
          "title": "Create RoadmapProcess",
          "sections": [
            {
              "id": "RoadmapProcess-main",
              "title": "RoadmapProcess fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableTableName",
                  "label": "AirtableTableName",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "matchKey",
                  "label": "MatchKey",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapProcess",
          "sections": [
            {
              "id": "RoadmapProcess-main",
              "title": "RoadmapProcess fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableTableName",
                  "label": "AirtableTableName",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "matchKey",
                  "label": "MatchKey",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-use-case",
      "entityName": "RoadmapUseCase",
      "label": "RoadmapUseCase",
      "form": {
        "entity": "RoadmapUseCase",
        "create": {
          "title": "Create RoadmapUseCase",
          "sections": [
            {
              "id": "RoadmapUseCase-main",
              "title": "RoadmapUseCase fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableTableName",
                  "label": "AirtableTableName",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "linkedProcessKey",
                  "label": "LinkedProcessKey",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapUseCase",
          "sections": [
            {
              "id": "RoadmapUseCase-main",
              "title": "RoadmapUseCase fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableTableName",
                  "label": "AirtableTableName",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "linkedProcessKey",
                  "label": "LinkedProcessKey",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-use-case-digest",
      "entityName": "RoadmapUseCaseDigest",
      "label": "RoadmapUseCaseDigest",
      "form": {
        "entity": "RoadmapUseCaseDigest",
        "create": {
          "title": "Create RoadmapUseCaseDigest",
          "sections": [
            {
              "id": "RoadmapUseCaseDigest-main",
              "title": "RoadmapUseCaseDigest fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCase",
                  "label": "UseCase",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCaseId",
                  "label": "UseCaseId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "DRAFT",
                      "label": "DRAFT"
                    },
                    {
                      "value": "READY",
                      "label": "READY"
                    },
                    {
                      "value": "NEEDS_APPROVAL",
                      "label": "NEEDS APPROVAL"
                    },
                    {
                      "value": "FAIL",
                      "label": "FAIL"
                    }
                  ]
                },
                {
                  "field": "stopReason",
                  "label": "StopReason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "digestJson",
                  "label": "DigestJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "reasonsJson",
                  "label": "ReasonsJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "inputsHash",
                  "label": "InputsHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "model",
                  "label": "Model",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "promptVersion",
                  "label": "PromptVersion",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapUseCaseDigest",
          "sections": [
            {
              "id": "RoadmapUseCaseDigest-main",
              "title": "RoadmapUseCaseDigest fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCase",
                  "label": "UseCase",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCaseId",
                  "label": "UseCaseId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "DRAFT",
                      "label": "DRAFT"
                    },
                    {
                      "value": "READY",
                      "label": "READY"
                    },
                    {
                      "value": "NEEDS_APPROVAL",
                      "label": "NEEDS APPROVAL"
                    },
                    {
                      "value": "FAIL",
                      "label": "FAIL"
                    }
                  ]
                },
                {
                  "field": "stopReason",
                  "label": "StopReason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "digestJson",
                  "label": "DigestJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "reasonsJson",
                  "label": "ReasonsJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "inputsHash",
                  "label": "InputsHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "model",
                  "label": "Model",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "promptVersion",
                  "label": "PromptVersion",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-segment",
      "entityName": "RoadmapSegment",
      "label": "RoadmapSegment",
      "form": {
        "entity": "RoadmapSegment",
        "create": {
          "title": "Create RoadmapSegment",
          "sections": [
            {
              "id": "RoadmapSegment-main",
              "title": "RoadmapSegment fields",
              "fields": [
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "purpose",
                  "label": "Purpose",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "solutionType",
                  "label": "SolutionType",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "segmentMetaJson",
                  "label": "SegmentMetaJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "aiWhatItDoes",
                  "label": "AiWhatItDoes",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "impact",
                  "label": "Impact",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "applicationProfileAt",
                  "label": "ApplicationProfileAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "applicationProfileInputsHash",
                  "label": "ApplicationProfileInputsHash",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "applicationProfileJson",
                  "label": "ApplicationProfileJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "draftStatus",
                  "label": "DraftStatus",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "draftInputsHash",
                  "label": "DraftInputsHash",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "draftMissingInfo",
                  "label": "DraftMissingInfo",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "draftEvidenceFieldRefs",
                  "label": "DraftEvidenceFieldRefs",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "draftGeneratedAt",
                  "label": "DraftGeneratedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsGeneratedAt",
                  "label": "DetailsGeneratedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsInputsHash",
                  "label": "DetailsInputsHash",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsStopReason",
                  "label": "DetailsStopReason",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsMarkdown",
                  "label": "DetailsMarkdown",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsJson",
                  "label": "DetailsJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsMissingInfo",
                  "label": "DetailsMissingInfo",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsEvidenceIds",
                  "label": "DetailsEvidenceIds",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsGeneratedByUserId",
                  "label": "DetailsGeneratedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapSegment",
          "sections": [
            {
              "id": "RoadmapSegment-main",
              "title": "RoadmapSegment fields",
              "fields": [
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "purpose",
                  "label": "Purpose",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "solutionType",
                  "label": "SolutionType",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "segmentMetaJson",
                  "label": "SegmentMetaJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "aiWhatItDoes",
                  "label": "AiWhatItDoes",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "impact",
                  "label": "Impact",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "applicationProfileAt",
                  "label": "ApplicationProfileAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "applicationProfileInputsHash",
                  "label": "ApplicationProfileInputsHash",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "applicationProfileJson",
                  "label": "ApplicationProfileJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "draftStatus",
                  "label": "DraftStatus",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "draftInputsHash",
                  "label": "DraftInputsHash",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "draftMissingInfo",
                  "label": "DraftMissingInfo",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "draftEvidenceFieldRefs",
                  "label": "DraftEvidenceFieldRefs",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "draftGeneratedAt",
                  "label": "DraftGeneratedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsGeneratedAt",
                  "label": "DetailsGeneratedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsInputsHash",
                  "label": "DetailsInputsHash",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsStopReason",
                  "label": "DetailsStopReason",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsMarkdown",
                  "label": "DetailsMarkdown",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsJson",
                  "label": "DetailsJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsMissingInfo",
                  "label": "DetailsMissingInfo",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsEvidenceIds",
                  "label": "DetailsEvidenceIds",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "detailsGeneratedByUserId",
                  "label": "DetailsGeneratedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-application-blueprint",
      "entityName": "RoadmapApplicationBlueprint",
      "label": "RoadmapApplicationBlueprint",
      "form": {
        "entity": "RoadmapApplicationBlueprint",
        "create": {
          "title": "Create RoadmapApplicationBlueprint",
          "sections": [
            {
              "id": "RoadmapApplicationBlueprint-main",
              "title": "RoadmapApplicationBlueprint fields",
              "fields": [
                {
                  "field": "roadmapProject",
                  "label": "RoadmapProject",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "roadmapProjectId",
                  "label": "RoadmapProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "segment",
                  "label": "Segment",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "segmentId",
                  "label": "SegmentId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "DRAFT",
                      "label": "DRAFT"
                    },
                    {
                      "value": "IN_REVIEW",
                      "label": "IN REVIEW"
                    },
                    {
                      "value": "READY",
                      "label": "READY"
                    },
                    {
                      "value": "NEEDS_APPROVAL",
                      "label": "NEEDS APPROVAL"
                    },
                    {
                      "value": "APPROVED",
                      "label": "APPROVED"
                    }
                  ]
                },
                {
                  "field": "blueprintJson",
                  "label": "BlueprintJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "blueprintMarkdown",
                  "label": "BlueprintMarkdown",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "inputsHash",
                  "label": "InputsHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "reasonsJson",
                  "label": "ReasonsJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "approvals",
                  "label": "Approvals",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "approvedAt",
                  "label": "ApprovedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "approvedByUserId",
                  "label": "ApprovedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapApplicationBlueprint",
          "sections": [
            {
              "id": "RoadmapApplicationBlueprint-main",
              "title": "RoadmapApplicationBlueprint fields",
              "fields": [
                {
                  "field": "roadmapProject",
                  "label": "RoadmapProject",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "roadmapProjectId",
                  "label": "RoadmapProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "segment",
                  "label": "Segment",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "segmentId",
                  "label": "SegmentId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "DRAFT",
                      "label": "DRAFT"
                    },
                    {
                      "value": "IN_REVIEW",
                      "label": "IN REVIEW"
                    },
                    {
                      "value": "READY",
                      "label": "READY"
                    },
                    {
                      "value": "NEEDS_APPROVAL",
                      "label": "NEEDS APPROVAL"
                    },
                    {
                      "value": "APPROVED",
                      "label": "APPROVED"
                    }
                  ]
                },
                {
                  "field": "blueprintJson",
                  "label": "BlueprintJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "blueprintMarkdown",
                  "label": "BlueprintMarkdown",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "inputsHash",
                  "label": "InputsHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "reasonsJson",
                  "label": "ReasonsJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "approvals",
                  "label": "Approvals",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "approvedAt",
                  "label": "ApprovedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "approvedByUserId",
                  "label": "ApprovedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-roadmap-suggestion",
      "entityName": "RoadmapRoadmapSuggestion",
      "label": "RoadmapRoadmapSuggestion",
      "form": {
        "entity": "RoadmapRoadmapSuggestion",
        "create": {
          "title": "Create RoadmapRoadmapSuggestion",
          "sections": [
            {
              "id": "RoadmapRoadmapSuggestion-main",
              "title": "RoadmapRoadmapSuggestion fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "DRAFT",
                      "label": "DRAFT"
                    },
                    {
                      "value": "GENERATED",
                      "label": "GENERATED"
                    },
                    {
                      "value": "EDITED",
                      "label": "EDITED"
                    },
                    {
                      "value": "APPROVED",
                      "label": "APPROVED"
                    }
                  ]
                },
                {
                  "field": "revision",
                  "label": "Revision",
                  "editor": "number",
                  "required": true,
                  "options": []
                },
                {
                  "field": "inputsHash",
                  "label": "InputsHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "stopReason",
                  "label": "StopReason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "paramsJson",
                  "label": "ParamsJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "suggestionJson",
                  "label": "SuggestionJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "approvals",
                  "label": "Approvals",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "auditLog",
                  "label": "AuditLog",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "generatedByUserId",
                  "label": "GeneratedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "lastEditedByUserId",
                  "label": "LastEditedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapRoadmapSuggestion",
          "sections": [
            {
              "id": "RoadmapRoadmapSuggestion-main",
              "title": "RoadmapRoadmapSuggestion fields",
              "fields": [
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "DRAFT",
                      "label": "DRAFT"
                    },
                    {
                      "value": "GENERATED",
                      "label": "GENERATED"
                    },
                    {
                      "value": "EDITED",
                      "label": "EDITED"
                    },
                    {
                      "value": "APPROVED",
                      "label": "APPROVED"
                    }
                  ]
                },
                {
                  "field": "revision",
                  "label": "Revision",
                  "editor": "number",
                  "required": true,
                  "options": []
                },
                {
                  "field": "inputsHash",
                  "label": "InputsHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "stopReason",
                  "label": "StopReason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "paramsJson",
                  "label": "ParamsJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "suggestionJson",
                  "label": "SuggestionJson",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "approvals",
                  "label": "Approvals",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "auditLog",
                  "label": "AuditLog",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "generatedByUserId",
                  "label": "GeneratedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "lastEditedByUserId",
                  "label": "LastEditedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-forge-handoff",
      "entityName": "RoadmapForgeHandoff",
      "label": "RoadmapForgeHandoff",
      "form": {
        "entity": "RoadmapForgeHandoff",
        "create": {
          "title": "Create RoadmapForgeHandoff",
          "sections": [
            {
              "id": "RoadmapForgeHandoff-main",
              "title": "RoadmapForgeHandoff fields",
              "fields": [
                {
                  "field": "roadmapProject",
                  "label": "RoadmapProject",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "roadmapProjectId",
                  "label": "RoadmapProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "segment",
                  "label": "Segment",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "segmentId",
                  "label": "SegmentId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "forgeProjectId",
                  "label": "ForgeProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "seedPackHash",
                  "label": "SeedPackHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "seedPackPath",
                  "label": "SeedPackPath",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "stopReason",
                  "label": "StopReason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "createdByUserId",
                  "label": "CreatedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapForgeHandoff",
          "sections": [
            {
              "id": "RoadmapForgeHandoff-main",
              "title": "RoadmapForgeHandoff fields",
              "fields": [
                {
                  "field": "roadmapProject",
                  "label": "RoadmapProject",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "roadmapProjectId",
                  "label": "RoadmapProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "segment",
                  "label": "Segment",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "segmentId",
                  "label": "SegmentId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "forgeProjectId",
                  "label": "ForgeProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "seedPackHash",
                  "label": "SeedPackHash",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "seedPackPath",
                  "label": "SeedPackPath",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "stopReason",
                  "label": "StopReason",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "createdByUserId",
                  "label": "CreatedByUserId",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-user",
      "entityName": "RoadmapUser",
      "label": "RoadmapUser",
      "form": {
        "entity": "RoadmapUser",
        "create": {
          "title": "Create RoadmapUser",
          "sections": [
            {
              "id": "RoadmapUser-main",
              "title": "RoadmapUser fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapUser",
          "sections": [
            {
              "id": "RoadmapUser-main",
              "title": "RoadmapUser fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-app",
      "entityName": "RoadmapApp",
      "label": "RoadmapApp",
      "form": {
        "entity": "RoadmapApp",
        "create": {
          "title": "Create RoadmapApp",
          "sections": [
            {
              "id": "RoadmapApp-main",
              "title": "RoadmapApp fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapApp",
          "sections": [
            {
              "id": "RoadmapApp-main",
              "title": "RoadmapApp fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-integration",
      "entityName": "RoadmapIntegration",
      "label": "RoadmapIntegration",
      "form": {
        "entity": "RoadmapIntegration",
        "create": {
          "title": "Create RoadmapIntegration",
          "sections": [
            {
              "id": "RoadmapIntegration-main",
              "title": "RoadmapIntegration fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapIntegration",
          "sections": [
            {
              "id": "RoadmapIntegration-main",
              "title": "RoadmapIntegration fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-technical-assessment",
      "entityName": "RoadmapTechnicalAssessment",
      "label": "RoadmapTechnicalAssessment",
      "form": {
        "entity": "RoadmapTechnicalAssessment",
        "create": {
          "title": "Create RoadmapTechnicalAssessment",
          "sections": [
            {
              "id": "RoadmapTechnicalAssessment-main",
              "title": "RoadmapTechnicalAssessment fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapTechnicalAssessment",
          "sections": [
            {
              "id": "RoadmapTechnicalAssessment-main",
              "title": "RoadmapTechnicalAssessment fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-data-risk-checklist",
      "entityName": "RoadmapDataRiskChecklist",
      "label": "RoadmapDataRiskChecklist",
      "form": {
        "entity": "RoadmapDataRiskChecklist",
        "create": {
          "title": "Create RoadmapDataRiskChecklist",
          "sections": [
            {
              "id": "RoadmapDataRiskChecklist-main",
              "title": "RoadmapDataRiskChecklist fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapDataRiskChecklist",
          "sections": [
            {
              "id": "RoadmapDataRiskChecklist-main",
              "title": "RoadmapDataRiskChecklist fields",
              "fields": [
                {
                  "field": "airtableBaseId",
                  "label": "AirtableBaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "airtableRecordId",
                  "label": "AirtableRecordId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "raw",
                  "label": "Raw",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-project-member",
      "entityName": "RoadmapProjectMember",
      "label": "RoadmapProjectMember",
      "form": {
        "entity": "RoadmapProjectMember",
        "create": {
          "title": "Create RoadmapProjectMember",
          "sections": [
            {
              "id": "RoadmapProjectMember-main",
              "title": "RoadmapProjectMember fields",
              "fields": [
                {
                  "field": "customer",
                  "label": "Customer",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customerId",
                  "label": "CustomerId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "VIEWER",
                      "label": "VIEWER"
                    },
                    {
                      "value": "EDITOR",
                      "label": "EDITOR"
                    },
                    {
                      "value": "REVIEWER",
                      "label": "REVIEWER"
                    },
                    {
                      "value": "ADMIN",
                      "label": "ADMIN"
                    }
                  ]
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapProjectMember",
          "sections": [
            {
              "id": "RoadmapProjectMember-main",
              "title": "RoadmapProjectMember fields",
              "fields": [
                {
                  "field": "customer",
                  "label": "Customer",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customerId",
                  "label": "CustomerId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "VIEWER",
                      "label": "VIEWER"
                    },
                    {
                      "value": "EDITOR",
                      "label": "EDITOR"
                    },
                    {
                      "value": "REVIEWER",
                      "label": "REVIEWER"
                    },
                    {
                      "value": "ADMIN",
                      "label": "ADMIN"
                    }
                  ]
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-scoring-factor",
      "entityName": "RoadmapScoringFactor",
      "label": "RoadmapScoringFactor",
      "form": {
        "entity": "RoadmapScoringFactor",
        "create": {
          "title": "Create RoadmapScoringFactor",
          "sections": [
            {
              "id": "RoadmapScoringFactor-main",
              "title": "RoadmapScoringFactor fields",
              "fields": [
                {
                  "field": "factor",
                  "label": "Factor",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "weight",
                  "label": "Weight",
                  "editor": "number",
                  "required": true,
                  "options": []
                },
                {
                  "field": "owner",
                  "label": "Owner",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "category",
                  "label": "Category",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapScoringFactor",
          "sections": [
            {
              "id": "RoadmapScoringFactor-main",
              "title": "RoadmapScoringFactor fields",
              "fields": [
                {
                  "field": "factor",
                  "label": "Factor",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "weight",
                  "label": "Weight",
                  "editor": "number",
                  "required": true,
                  "options": []
                },
                {
                  "field": "owner",
                  "label": "Owner",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "category",
                  "label": "Category",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-scoring-entry",
      "entityName": "RoadmapScoringEntry",
      "label": "RoadmapScoringEntry",
      "form": {
        "entity": "RoadmapScoringEntry",
        "create": {
          "title": "Create RoadmapScoringEntry",
          "sections": [
            {
              "id": "RoadmapScoringEntry-main",
              "title": "RoadmapScoringEntry fields",
              "fields": [
                {
                  "field": "score",
                  "label": "Score",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": false,
                  "options": [
                    {
                      "value": "VIEWER",
                      "label": "VIEWER"
                    },
                    {
                      "value": "EDITOR",
                      "label": "EDITOR"
                    },
                    {
                      "value": "REVIEWER",
                      "label": "REVIEWER"
                    },
                    {
                      "value": "ADMIN",
                      "label": "ADMIN"
                    }
                  ]
                },
                {
                  "field": "scoringRole",
                  "label": "ScoringRole",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "factor",
                  "label": "Factor",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "factorId",
                  "label": "FactorId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCase",
                  "label": "UseCase",
                  "editor": "select",
                  "required": false,
                  "options": []
                },
                {
                  "field": "useCaseId",
                  "label": "UseCaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "segment",
                  "label": "Segment",
                  "editor": "select",
                  "required": false,
                  "options": []
                },
                {
                  "field": "segmentId",
                  "label": "SegmentId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "targetType",
                  "label": "TargetType",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "USE_CASE",
                      "label": "USE CASE"
                    },
                    {
                      "value": "SEGMENT",
                      "label": "SEGMENT"
                    }
                  ]
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapScoringEntry",
          "sections": [
            {
              "id": "RoadmapScoringEntry-main",
              "title": "RoadmapScoringEntry fields",
              "fields": [
                {
                  "field": "score",
                  "label": "Score",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": false,
                  "options": [
                    {
                      "value": "VIEWER",
                      "label": "VIEWER"
                    },
                    {
                      "value": "EDITOR",
                      "label": "EDITOR"
                    },
                    {
                      "value": "REVIEWER",
                      "label": "REVIEWER"
                    },
                    {
                      "value": "ADMIN",
                      "label": "ADMIN"
                    }
                  ]
                },
                {
                  "field": "scoringRole",
                  "label": "ScoringRole",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "factor",
                  "label": "Factor",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "factorId",
                  "label": "FactorId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCase",
                  "label": "UseCase",
                  "editor": "select",
                  "required": false,
                  "options": []
                },
                {
                  "field": "useCaseId",
                  "label": "UseCaseId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "segment",
                  "label": "Segment",
                  "editor": "select",
                  "required": false,
                  "options": []
                },
                {
                  "field": "segmentId",
                  "label": "SegmentId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "targetType",
                  "label": "TargetType",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "USE_CASE",
                      "label": "USE CASE"
                    },
                    {
                      "value": "SEGMENT",
                      "label": "SEGMENT"
                    }
                  ]
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-process-use-case",
      "entityName": "RoadmapProcessUseCase",
      "label": "RoadmapProcessUseCase",
      "form": {
        "entity": "RoadmapProcessUseCase",
        "create": {
          "title": "Create RoadmapProcessUseCase",
          "sections": [
            {
              "id": "RoadmapProcessUseCase-main",
              "title": "RoadmapProcessUseCase fields",
              "fields": [
                {
                  "field": "process",
                  "label": "Process",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "processId",
                  "label": "ProcessId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCase",
                  "label": "UseCase",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCaseId",
                  "label": "UseCaseId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "assignmentMetaJson",
                  "label": "AssignmentMetaJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapProcessUseCase",
          "sections": [
            {
              "id": "RoadmapProcessUseCase-main",
              "title": "RoadmapProcessUseCase fields",
              "fields": [
                {
                  "field": "process",
                  "label": "Process",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "processId",
                  "label": "ProcessId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCase",
                  "label": "UseCase",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCaseId",
                  "label": "UseCaseId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "assignmentMetaJson",
                  "label": "AssignmentMetaJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "roadmap-segment-use-case",
      "entityName": "RoadmapSegmentUseCase",
      "label": "RoadmapSegmentUseCase",
      "form": {
        "entity": "RoadmapSegmentUseCase",
        "create": {
          "title": "Create RoadmapSegmentUseCase",
          "sections": [
            {
              "id": "RoadmapSegmentUseCase-main",
              "title": "RoadmapSegmentUseCase fields",
              "fields": [
                {
                  "field": "segment",
                  "label": "Segment",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "segmentId",
                  "label": "SegmentId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCase",
                  "label": "UseCase",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCaseId",
                  "label": "UseCaseId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "assignmentMetaJson",
                  "label": "AssignmentMetaJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit RoadmapSegmentUseCase",
          "sections": [
            {
              "id": "RoadmapSegmentUseCase-main",
              "title": "RoadmapSegmentUseCase fields",
              "fields": [
                {
                  "field": "segment",
                  "label": "Segment",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "segmentId",
                  "label": "SegmentId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCase",
                  "label": "UseCase",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "useCaseId",
                  "label": "UseCaseId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "assignmentMetaJson",
                  "label": "AssignmentMetaJson",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "customer",
      "entityName": "Customer",
      "label": "Customer",
      "list": {
        "columns": [
          {
            "id": "name",
            "field": "name",
            "label": "Name",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "code",
            "field": "code",
            "label": "Code",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "sector",
            "field": "sector",
            "label": "Sector",
            "type": "enum",
            "isPrimary": false
          },
          {
            "id": "countryCode",
            "field": "countryCode",
            "label": "Country",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "contextGenerationStatus",
            "field": "contextGenerationStatus",
            "label": "Context Status",
            "type": "enum",
            "isPrimary": false
          },
          {
            "id": "createdAt",
            "field": "createdAt",
            "label": "Created",
            "type": "date",
            "isPrimary": false
          }
        ]
      },
      "detail": {
        "sections": [
          {
            "id": "customer_detail-main",
            "label": "Customer Detail",
            "fields": [
              {
                "field": "name",
                "label": "Name",
                "emphasize": false
              },
              {
                "field": "code",
                "label": "Code",
                "emphasize": false
              },
              {
                "field": "sector",
                "label": "Sector",
                "emphasize": false
              },
              {
                "field": "countryCode",
                "label": "CountryCode",
                "emphasize": false
              },
              {
                "field": "context",
                "label": "Context",
                "emphasize": false
              },
              {
                "field": "contextSources",
                "label": "ContextSources",
                "emphasize": false
              },
              {
                "field": "contextGeneratedAt",
                "label": "ContextGeneratedAt",
                "emphasize": false
              },
              {
                "field": "contextGeneratedBy",
                "label": "ContextGeneratedBy",
                "emphasize": false
              },
              {
                "field": "contextGenerationStatus",
                "label": "ContextGenerationStatus",
                "emphasize": false
              },
              {
                "field": "contextGenerationError",
                "label": "ContextGenerationError",
                "emphasize": false
              },
              {
                "field": "projects",
                "label": "Projects",
                "emphasize": false
              },
              {
                "field": "createdAt",
                "label": "CreatedAt",
                "emphasize": false
              },
              {
                "field": "updatedAt",
                "label": "UpdatedAt",
                "emphasize": false
              }
            ]
          }
        ]
      },
      "form": {
        "entity": "Customer",
        "create": {
          "title": "Create Customer",
          "sections": [
            {
              "id": "Customer-main",
              "title": "Customer fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "code",
                  "label": "Code",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "sector",
                  "label": "Sector",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "tech",
                      "label": "Tech"
                    },
                    {
                      "value": "industry",
                      "label": "Industry"
                    },
                    {
                      "value": "services",
                      "label": "Services"
                    },
                    {
                      "value": "other",
                      "label": "Other"
                    }
                  ]
                },
                {
                  "field": "countryCode",
                  "label": "CountryCode",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "context",
                  "label": "Context",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextSources",
                  "label": "ContextSources",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGeneratedAt",
                  "label": "ContextGeneratedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGeneratedBy",
                  "label": "ContextGeneratedBy",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGenerationStatus",
                  "label": "ContextGenerationStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "idle",
                      "label": "Idle"
                    },
                    {
                      "value": "running",
                      "label": "Running"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    }
                  ]
                },
                {
                  "field": "contextGenerationError",
                  "label": "ContextGenerationError",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit Customer",
          "sections": [
            {
              "id": "Customer-main",
              "title": "Customer fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "code",
                  "label": "Code",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "sector",
                  "label": "Sector",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "tech",
                      "label": "Tech"
                    },
                    {
                      "value": "industry",
                      "label": "Industry"
                    },
                    {
                      "value": "services",
                      "label": "Services"
                    },
                    {
                      "value": "other",
                      "label": "Other"
                    }
                  ]
                },
                {
                  "field": "countryCode",
                  "label": "CountryCode",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "context",
                  "label": "Context",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextSources",
                  "label": "ContextSources",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGeneratedAt",
                  "label": "ContextGeneratedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGeneratedBy",
                  "label": "ContextGeneratedBy",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGenerationStatus",
                  "label": "ContextGenerationStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "idle",
                      "label": "Idle"
                    },
                    {
                      "value": "running",
                      "label": "Running"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    }
                  ]
                },
                {
                  "field": "contextGenerationError",
                  "label": "ContextGenerationError",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "customer-member",
      "entityName": "CustomerMember",
      "label": "CustomerMember",
      "form": {
        "entity": "CustomerMember",
        "create": {
          "title": "Create CustomerMember",
          "sections": [
            {
              "id": "CustomerMember-main",
              "title": "CustomerMember fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customer",
                  "label": "Customer",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customerId",
                  "label": "CustomerId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "OWNER",
                      "label": "OWNER"
                    },
                    {
                      "value": "ADMIN",
                      "label": "ADMIN"
                    },
                    {
                      "value": "EDITOR",
                      "label": "EDITOR"
                    },
                    {
                      "value": "VIEWER",
                      "label": "VIEWER"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit CustomerMember",
          "sections": [
            {
              "id": "CustomerMember-main",
              "title": "CustomerMember fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customer",
                  "label": "Customer",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customerId",
                  "label": "CustomerId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "user",
                  "label": "User",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "userId",
                  "label": "UserId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "role",
                  "label": "Role",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "OWNER",
                      "label": "OWNER"
                    },
                    {
                      "value": "ADMIN",
                      "label": "ADMIN"
                    },
                    {
                      "value": "EDITOR",
                      "label": "EDITOR"
                    },
                    {
                      "value": "VIEWER",
                      "label": "VIEWER"
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "project",
      "entityName": "Project",
      "label": "Project",
      "list": {
        "columns": [
          {
            "id": "name",
            "field": "name",
            "label": "Name",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "code",
            "field": "code",
            "label": "Code",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "customer",
            "field": "customer",
            "label": "Customer",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "status",
            "field": "status",
            "label": "Status",
            "type": "enum",
            "isPrimary": false
          },
          {
            "id": "startDate",
            "field": "startDate",
            "label": "Start Date",
            "type": "date",
            "isPrimary": false
          },
          {
            "id": "endDate",
            "field": "endDate",
            "label": "End Date",
            "type": "date",
            "isPrimary": false
          }
        ]
      },
      "detail": {
        "sections": [
          {
            "id": "project_detail-main",
            "label": "Project Detail",
            "fields": [
              {
                "field": "customer",
                "label": "Customer",
                "emphasize": false
              },
              {
                "field": "name",
                "label": "Name",
                "emphasize": false
              },
              {
                "field": "code",
                "label": "Code",
                "emphasize": false
              },
              {
                "field": "status",
                "label": "Status",
                "emphasize": false
              },
              {
                "field": "startDate",
                "label": "StartDate",
                "emphasize": false
              },
              {
                "field": "endDate",
                "label": "EndDate",
                "emphasize": false
              },
              {
                "field": "requirements",
                "label": "Requirements",
                "emphasize": false
              },
              {
                "field": "workItems",
                "label": "WorkItems",
                "emphasize": false
              },
              {
                "field": "specSections",
                "label": "SpecSections",
                "emphasize": false
              },
              {
                "field": "meetings",
                "label": "Meetings",
                "emphasize": false
              },
              {
                "field": "createdAt",
                "label": "CreatedAt",
                "emphasize": false
              },
              {
                "field": "updatedAt",
                "label": "UpdatedAt",
                "emphasize": false
              }
            ]
          }
        ]
      },
      "form": {
        "entity": "Project",
        "create": {
          "title": "Create Project",
          "sections": [
            {
              "id": "Project-main",
              "title": "Project fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customer",
                  "label": "Customer",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customerId",
                  "label": "CustomerId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "code",
                  "label": "Code",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "planned",
                      "label": "Planned"
                    },
                    {
                      "value": "in_progress",
                      "label": "In Progress"
                    },
                    {
                      "value": "completed",
                      "label": "Completed"
                    },
                    {
                      "value": "archived",
                      "label": "Archived"
                    }
                  ]
                },
                {
                  "field": "context",
                  "label": "Context",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextSources",
                  "label": "ContextSources",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGeneratedAt",
                  "label": "ContextGeneratedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGeneratedBy",
                  "label": "ContextGeneratedBy",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGenerationStatus",
                  "label": "ContextGenerationStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "idle",
                      "label": "Idle"
                    },
                    {
                      "value": "running",
                      "label": "Running"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    }
                  ]
                },
                {
                  "field": "contextGenerationError",
                  "label": "ContextGenerationError",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "preDiscoveryQuestions",
                  "label": "PreDiscoveryQuestions",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "preDiscoveryQuestionsGeneratedAt",
                  "label": "PreDiscoveryQuestionsGeneratedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "preDiscoveryQuestionsGeneratedBy",
                  "label": "PreDiscoveryQuestionsGeneratedBy",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "preDiscoveryQuestionsStatus",
                  "label": "PreDiscoveryQuestionsStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "idle",
                      "label": "Idle"
                    },
                    {
                      "value": "running",
                      "label": "Running"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    }
                  ]
                },
                {
                  "field": "preDiscoveryQuestionsError",
                  "label": "PreDiscoveryQuestionsError",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "startDate",
                  "label": "StartDate",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "endDate",
                  "label": "EndDate",
                  "editor": "date",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit Project",
          "sections": [
            {
              "id": "Project-main",
              "title": "Project fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customer",
                  "label": "Customer",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "customerId",
                  "label": "CustomerId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "code",
                  "label": "Code",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "planned",
                      "label": "Planned"
                    },
                    {
                      "value": "in_progress",
                      "label": "In Progress"
                    },
                    {
                      "value": "completed",
                      "label": "Completed"
                    },
                    {
                      "value": "archived",
                      "label": "Archived"
                    }
                  ]
                },
                {
                  "field": "context",
                  "label": "Context",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextSources",
                  "label": "ContextSources",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGeneratedAt",
                  "label": "ContextGeneratedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGeneratedBy",
                  "label": "ContextGeneratedBy",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "contextGenerationStatus",
                  "label": "ContextGenerationStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "idle",
                      "label": "Idle"
                    },
                    {
                      "value": "running",
                      "label": "Running"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    }
                  ]
                },
                {
                  "field": "contextGenerationError",
                  "label": "ContextGenerationError",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "preDiscoveryQuestions",
                  "label": "PreDiscoveryQuestions",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "preDiscoveryQuestionsGeneratedAt",
                  "label": "PreDiscoveryQuestionsGeneratedAt",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "preDiscoveryQuestionsGeneratedBy",
                  "label": "PreDiscoveryQuestionsGeneratedBy",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "preDiscoveryQuestionsStatus",
                  "label": "PreDiscoveryQuestionsStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "idle",
                      "label": "Idle"
                    },
                    {
                      "value": "running",
                      "label": "Running"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    }
                  ]
                },
                {
                  "field": "preDiscoveryQuestionsError",
                  "label": "PreDiscoveryQuestionsError",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "startDate",
                  "label": "StartDate",
                  "editor": "date",
                  "required": false,
                  "options": []
                },
                {
                  "field": "endDate",
                  "label": "EndDate",
                  "editor": "date",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "project-brief",
      "entityName": "ProjectBrief",
      "label": "ProjectBrief",
      "form": {
        "entity": "ProjectBrief",
        "create": {
          "title": "Create ProjectBrief",
          "sections": [
            {
              "id": "ProjectBrief-main",
              "title": "ProjectBrief fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "DRAFT",
                      "label": "DRAFT"
                    },
                    {
                      "value": "APPROVED",
                      "label": "APPROVED"
                    }
                  ]
                },
                {
                  "field": "content",
                  "label": "Content",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit ProjectBrief",
          "sections": [
            {
              "id": "ProjectBrief-main",
              "title": "ProjectBrief fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "DRAFT",
                      "label": "DRAFT"
                    },
                    {
                      "value": "APPROVED",
                      "label": "APPROVED"
                    }
                  ]
                },
                {
                  "field": "content",
                  "label": "Content",
                  "editor": "text",
                  "required": true,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "requirement",
      "entityName": "Requirement",
      "label": "Requirement",
      "list": {
        "columns": [
          {
            "id": "title",
            "field": "title",
            "label": "Title",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "project",
            "field": "project",
            "label": "Project",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "reviewStatus",
            "field": "reviewStatus",
            "label": "Review Status",
            "type": "enum",
            "isPrimary": false
          },
          {
            "id": "aiReviewStatus",
            "field": "aiReviewStatus",
            "label": "AI Review Status",
            "type": "enum",
            "isPrimary": false
          },
          {
            "id": "generationRequested",
            "field": "generationRequested",
            "label": "Generation Requested",
            "type": "badge",
            "isPrimary": false
          },
          {
            "id": "generationStatus",
            "field": "generationStatus",
            "label": "Generation Status",
            "type": "enum",
            "isPrimary": false
          }
        ]
      },
      "detail": {
        "sections": [
          {
            "id": "requirement_detail-main",
            "label": "Requirement Detail",
            "fields": [
              {
                "field": "project",
                "label": "Project",
                "emphasize": false
              },
              {
                "field": "title",
                "label": "Title",
                "emphasize": false
              },
              {
                "field": "description",
                "label": "Description",
                "emphasize": false
              },
              {
                "field": "sourceType",
                "label": "SourceType",
                "emphasize": false
              },
              {
                "field": "sourceMeetingId",
                "label": "SourceMeetingId",
                "emphasize": false
              },
              {
                "field": "sourceMeetingQuestionId",
                "label": "SourceMeetingQuestionId",
                "emphasize": false
              },
              {
                "field": "sourceDraftKey",
                "label": "SourceDraftKey",
                "emphasize": false
              },
              {
                "field": "sourceFileName",
                "label": "SourceFileName",
                "emphasize": false
              },
              {
                "field": "reviewStatus",
                "label": "ReviewStatus",
                "emphasize": false
              },
              {
                "field": "aiReviewStatus",
                "label": "AiReviewStatus",
                "emphasize": false
              },
              {
                "field": "generationRequested",
                "label": "GenerationRequested",
                "emphasize": false
              },
              {
                "field": "generationStatus",
                "label": "GenerationStatus",
                "emphasize": false
              },
              {
                "field": "generationTarget",
                "label": "GenerationTarget",
                "emphasize": false
              },
              {
                "field": "generatedSummary",
                "label": "GeneratedSummary",
                "emphasize": false
              },
              {
                "field": "generatedArtifacts",
                "label": "GeneratedArtifacts",
                "emphasize": false
              },
              {
                "field": "createdAt",
                "label": "CreatedAt",
                "emphasize": false
              },
              {
                "field": "updatedAt",
                "label": "UpdatedAt",
                "emphasize": false
              }
            ]
          }
        ]
      },
      "form": {
        "entity": "Requirement",
        "create": {
          "title": "Create Requirement",
          "sections": [
            {
              "id": "Requirement-main",
              "title": "Requirement fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "sourceType",
                  "label": "SourceType",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "manual",
                      "label": "Manual"
                    },
                    {
                      "value": "pdf_summary",
                      "label": "Pdf Summary"
                    },
                    {
                      "value": "meeting_ai",
                      "label": "Meeting Ai"
                    },
                    {
                      "value": "other_ai",
                      "label": "Other Ai"
                    }
                  ]
                },
                {
                  "field": "sourceMeetingId",
                  "label": "SourceMeetingId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceMeetingQuestionId",
                  "label": "SourceMeetingQuestionId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceDraftKey",
                  "label": "SourceDraftKey",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceFileName",
                  "label": "SourceFileName",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceFileId",
                  "label": "SourceFileId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewStatus",
                  "label": "ReviewStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "pending_review",
                      "label": "Pending Review"
                    },
                    {
                      "value": "in_discussion",
                      "label": "In Discussion"
                    },
                    {
                      "value": "approved",
                      "label": "Approved"
                    },
                    {
                      "value": "rejected",
                      "label": "Rejected"
                    }
                  ]
                },
                {
                  "field": "aiReviewStatus",
                  "label": "AiReviewStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "none",
                      "label": "None"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "accepted_as_is",
                      "label": "Accepted As Is"
                    },
                    {
                      "value": "edited",
                      "label": "Edited"
                    },
                    {
                      "value": "rejected",
                      "label": "Rejected"
                    },
                    {
                      "value": "not_applicable",
                      "label": "Not Applicable"
                    },
                    {
                      "value": "approved",
                      "label": "Approved"
                    },
                    {
                      "value": "changes_requested",
                      "label": "Changes Requested"
                    },
                    {
                      "value": "in_review",
                      "label": "In Review"
                    }
                  ]
                },
                {
                  "field": "generationRequested",
                  "label": "GenerationRequested",
                  "editor": "checkbox",
                  "required": true,
                  "options": []
                },
                {
                  "field": "generationStatus",
                  "label": "GenerationStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "not_requested",
                      "label": "Not Requested"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "not_planned",
                      "label": "Not Planned"
                    },
                    {
                      "value": "planned",
                      "label": "Planned"
                    },
                    {
                      "value": "in_progress",
                      "label": "In Progress"
                    },
                    {
                      "value": "blocked",
                      "label": "Blocked"
                    },
                    {
                      "value": "completed",
                      "label": "Completed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "dropped",
                      "label": "Dropped"
                    }
                  ]
                },
                {
                  "field": "generationTarget",
                  "label": "GenerationTarget",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "backend_module",
                      "label": "Backend Module"
                    },
                    {
                      "value": "frontend_module",
                      "label": "Frontend Module"
                    },
                    {
                      "value": "full_stack_module",
                      "label": "Full Stack Module"
                    }
                  ]
                },
                {
                  "field": "generatedSummary",
                  "label": "GeneratedSummary",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "generatedArtifacts",
                  "label": "GeneratedArtifacts",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit Requirement",
          "sections": [
            {
              "id": "Requirement-main",
              "title": "Requirement fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "sourceType",
                  "label": "SourceType",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "manual",
                      "label": "Manual"
                    },
                    {
                      "value": "pdf_summary",
                      "label": "Pdf Summary"
                    },
                    {
                      "value": "meeting_ai",
                      "label": "Meeting Ai"
                    },
                    {
                      "value": "other_ai",
                      "label": "Other Ai"
                    }
                  ]
                },
                {
                  "field": "sourceMeetingId",
                  "label": "SourceMeetingId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceMeetingQuestionId",
                  "label": "SourceMeetingQuestionId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceDraftKey",
                  "label": "SourceDraftKey",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceFileName",
                  "label": "SourceFileName",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceFileId",
                  "label": "SourceFileId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewStatus",
                  "label": "ReviewStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "pending_review",
                      "label": "Pending Review"
                    },
                    {
                      "value": "in_discussion",
                      "label": "In Discussion"
                    },
                    {
                      "value": "approved",
                      "label": "Approved"
                    },
                    {
                      "value": "rejected",
                      "label": "Rejected"
                    }
                  ]
                },
                {
                  "field": "aiReviewStatus",
                  "label": "AiReviewStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "none",
                      "label": "None"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "accepted_as_is",
                      "label": "Accepted As Is"
                    },
                    {
                      "value": "edited",
                      "label": "Edited"
                    },
                    {
                      "value": "rejected",
                      "label": "Rejected"
                    },
                    {
                      "value": "not_applicable",
                      "label": "Not Applicable"
                    },
                    {
                      "value": "approved",
                      "label": "Approved"
                    },
                    {
                      "value": "changes_requested",
                      "label": "Changes Requested"
                    },
                    {
                      "value": "in_review",
                      "label": "In Review"
                    }
                  ]
                },
                {
                  "field": "generationRequested",
                  "label": "GenerationRequested",
                  "editor": "checkbox",
                  "required": true,
                  "options": []
                },
                {
                  "field": "generationStatus",
                  "label": "GenerationStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "not_requested",
                      "label": "Not Requested"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "not_planned",
                      "label": "Not Planned"
                    },
                    {
                      "value": "planned",
                      "label": "Planned"
                    },
                    {
                      "value": "in_progress",
                      "label": "In Progress"
                    },
                    {
                      "value": "blocked",
                      "label": "Blocked"
                    },
                    {
                      "value": "completed",
                      "label": "Completed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "dropped",
                      "label": "Dropped"
                    }
                  ]
                },
                {
                  "field": "generationTarget",
                  "label": "GenerationTarget",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "backend_module",
                      "label": "Backend Module"
                    },
                    {
                      "value": "frontend_module",
                      "label": "Frontend Module"
                    },
                    {
                      "value": "full_stack_module",
                      "label": "Full Stack Module"
                    }
                  ]
                },
                {
                  "field": "generatedSummary",
                  "label": "GeneratedSummary",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "generatedArtifacts",
                  "label": "GeneratedArtifacts",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "spec-source",
      "entityName": "SpecSource",
      "label": "SpecSource",
      "form": {
        "entity": "SpecSource",
        "create": {
          "title": "Create SpecSource",
          "sections": [
            {
              "id": "SpecSource-main",
              "title": "SpecSource fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceType",
                  "label": "SourceType",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "uri",
                  "label": "Uri",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "documentId",
                  "label": "DocumentId",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit SpecSource",
          "sections": [
            {
              "id": "SpecSource-main",
              "title": "SpecSource fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "name",
                  "label": "Name",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceType",
                  "label": "SourceType",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "uri",
                  "label": "Uri",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "documentId",
                  "label": "DocumentId",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "spec-section",
      "entityName": "SpecSection",
      "label": "SpecSection",
      "list": {
        "columns": [
          {
            "id": "title",
            "field": "title",
            "label": "Title",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "specSource",
            "field": "specSource",
            "label": "Source",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "project",
            "field": "project",
            "label": "Project",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "dslKind",
            "field": "dslKind",
            "label": "DSL Kind",
            "type": "enum",
            "isPrimary": false
          },
          {
            "id": "reviewStatus",
            "field": "reviewStatus",
            "label": "Review Status",
            "type": "enum",
            "isPrimary": false
          },
          {
            "id": "aiReviewStatus",
            "field": "aiReviewStatus",
            "label": "AI Review Status",
            "type": "enum",
            "isPrimary": false
          },
          {
            "id": "dslStatus",
            "field": "dslStatus",
            "label": "DSL Status",
            "type": "enum",
            "isPrimary": false
          }
        ]
      },
      "detail": {
        "sections": [
          {
            "id": "spec_section_detail-main",
            "label": "Spec Section Overview",
            "fields": [
              {
                "field": "project",
                "label": "Project",
                "emphasize": false
              },
              {
                "field": "specSource",
                "label": "SpecSource",
                "emphasize": false
              },
              {
                "field": "title",
                "label": "Title",
                "emphasize": false
              },
              {
                "field": "category",
                "label": "Category",
                "emphasize": false
              },
              {
                "field": "kind",
                "label": "Kind",
                "emphasize": false
              },
              {
                "field": "dslKind",
                "label": "DslKind",
                "emphasize": false
              },
              {
                "field": "dslStatus",
                "label": "DslStatus",
                "emphasize": false
              },
              {
                "field": "reviewStatus",
                "label": "ReviewStatus",
                "emphasize": false
              },
              {
                "field": "aiReviewStatus",
                "label": "AiReviewStatus",
                "emphasize": false
              },
              {
                "field": "summary",
                "label": "Summary",
                "emphasize": false
              },
              {
                "field": "details",
                "label": "Details",
                "emphasize": false
              },
              {
                "field": "content",
                "label": "Content",
                "emphasize": false
              },
              {
                "field": "level",
                "label": "Level",
                "emphasize": false
              },
              {
                "field": "sequence",
                "label": "Sequence",
                "emphasize": false
              },
              {
                "field": "sourceMeetingId",
                "label": "SourceMeetingId",
                "emphasize": false
              },
              {
                "field": "sourceMeetingQuestionId",
                "label": "SourceMeetingQuestionId",
                "emphasize": false
              },
              {
                "field": "sourceDraftKey",
                "label": "SourceDraftKey",
                "emphasize": false
              },
              {
                "field": "createdAt",
                "label": "CreatedAt",
                "emphasize": false
              },
              {
                "field": "updatedAt",
                "label": "UpdatedAt",
                "emphasize": false
              }
            ]
          }
        ]
      },
      "form": {
        "entity": "SpecSection",
        "create": {
          "title": "Create SpecSection",
          "sections": [
            {
              "id": "SpecSection-main",
              "title": "SpecSection fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "specSource",
                  "label": "SpecSource",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "specSourceId",
                  "label": "SpecSourceId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "content",
                  "label": "Content",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "sourceMeetingId",
                  "label": "SourceMeetingId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceMeetingQuestionId",
                  "label": "SourceMeetingQuestionId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceDraftKey",
                  "label": "SourceDraftKey",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "category",
                  "label": "Category",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "kind",
                  "label": "Kind",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "summary",
                  "label": "Summary",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "details",
                  "label": "Details",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewStatus",
                  "label": "ReviewStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "pending_review",
                      "label": "Pending Review"
                    },
                    {
                      "value": "in_discussion",
                      "label": "In Discussion"
                    },
                    {
                      "value": "approved",
                      "label": "Approved"
                    },
                    {
                      "value": "rejected",
                      "label": "Rejected"
                    }
                  ]
                },
                {
                  "field": "aiReviewStatus",
                  "label": "AiReviewStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "none",
                      "label": "None"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "accepted_as_is",
                      "label": "Accepted As Is"
                    },
                    {
                      "value": "edited",
                      "label": "Edited"
                    },
                    {
                      "value": "rejected",
                      "label": "Rejected"
                    },
                    {
                      "value": "not_applicable",
                      "label": "Not Applicable"
                    },
                    {
                      "value": "approved",
                      "label": "Approved"
                    },
                    {
                      "value": "changes_requested",
                      "label": "Changes Requested"
                    },
                    {
                      "value": "in_review",
                      "label": "In Review"
                    }
                  ]
                },
                {
                  "field": "level",
                  "label": "Level",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sequence",
                  "label": "Sequence",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "dslKind",
                  "label": "DslKind",
                  "editor": "select",
                  "required": false,
                  "options": [
                    {
                      "value": "DOMAIN",
                      "label": "DOMAIN"
                    },
                    {
                      "value": "UI",
                      "label": "UI"
                    },
                    {
                      "value": "UI_FIELD",
                      "label": "UI FIELD"
                    },
                    {
                      "value": "WORKFLOW",
                      "label": "WORKFLOW"
                    },
                    {
                      "value": "WORKFLOW_STATE",
                      "label": "WORKFLOW STATE"
                    },
                    {
                      "value": "PERMISSION",
                      "label": "PERMISSION"
                    },
                    {
                      "value": "OTHER",
                      "label": "OTHER"
                    }
                  ]
                },
                {
                  "field": "dslStatus",
                  "label": "DslStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "NOT_STARTED",
                      "label": "NOT STARTED"
                    },
                    {
                      "value": "CANDIDATE",
                      "label": "CANDIDATE"
                    },
                    {
                      "value": "ACCEPTED",
                      "label": "ACCEPTED"
                    },
                    {
                      "value": "OUTDATED",
                      "label": "OUTDATED"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit SpecSection",
          "sections": [
            {
              "id": "SpecSection-main",
              "title": "SpecSection fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "specSource",
                  "label": "SpecSource",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "specSourceId",
                  "label": "SpecSourceId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "content",
                  "label": "Content",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "sourceMeetingId",
                  "label": "SourceMeetingId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceMeetingQuestionId",
                  "label": "SourceMeetingQuestionId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sourceDraftKey",
                  "label": "SourceDraftKey",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "category",
                  "label": "Category",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "kind",
                  "label": "Kind",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "summary",
                  "label": "Summary",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "details",
                  "label": "Details",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "reviewStatus",
                  "label": "ReviewStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "pending_review",
                      "label": "Pending Review"
                    },
                    {
                      "value": "in_discussion",
                      "label": "In Discussion"
                    },
                    {
                      "value": "approved",
                      "label": "Approved"
                    },
                    {
                      "value": "rejected",
                      "label": "Rejected"
                    }
                  ]
                },
                {
                  "field": "aiReviewStatus",
                  "label": "AiReviewStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "none",
                      "label": "None"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "accepted_as_is",
                      "label": "Accepted As Is"
                    },
                    {
                      "value": "edited",
                      "label": "Edited"
                    },
                    {
                      "value": "rejected",
                      "label": "Rejected"
                    },
                    {
                      "value": "not_applicable",
                      "label": "Not Applicable"
                    },
                    {
                      "value": "approved",
                      "label": "Approved"
                    },
                    {
                      "value": "changes_requested",
                      "label": "Changes Requested"
                    },
                    {
                      "value": "in_review",
                      "label": "In Review"
                    }
                  ]
                },
                {
                  "field": "level",
                  "label": "Level",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "sequence",
                  "label": "Sequence",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "dslKind",
                  "label": "DslKind",
                  "editor": "select",
                  "required": false,
                  "options": [
                    {
                      "value": "DOMAIN",
                      "label": "DOMAIN"
                    },
                    {
                      "value": "UI",
                      "label": "UI"
                    },
                    {
                      "value": "UI_FIELD",
                      "label": "UI FIELD"
                    },
                    {
                      "value": "WORKFLOW",
                      "label": "WORKFLOW"
                    },
                    {
                      "value": "WORKFLOW_STATE",
                      "label": "WORKFLOW STATE"
                    },
                    {
                      "value": "PERMISSION",
                      "label": "PERMISSION"
                    },
                    {
                      "value": "OTHER",
                      "label": "OTHER"
                    }
                  ]
                },
                {
                  "field": "dslStatus",
                  "label": "DslStatus",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "NOT_STARTED",
                      "label": "NOT STARTED"
                    },
                    {
                      "value": "CANDIDATE",
                      "label": "CANDIDATE"
                    },
                    {
                      "value": "ACCEPTED",
                      "label": "ACCEPTED"
                    },
                    {
                      "value": "OUTDATED",
                      "label": "OUTDATED"
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "work-item",
      "entityName": "WorkItem",
      "label": "WorkItem",
      "list": {
        "columns": [
          {
            "id": "title",
            "field": "title",
            "label": "Title",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "templateId",
            "field": "templateId",
            "label": "Template",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "project",
            "field": "project",
            "label": "Project",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "status",
            "field": "status",
            "label": "Status",
            "type": "enum",
            "isPrimary": false
          },
          {
            "id": "owner",
            "field": "owner",
            "label": "Owner",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "dueDate",
            "field": "dueDate",
            "label": "Due Date",
            "type": "date",
            "isPrimary": false
          },
          {
            "id": "impact",
            "field": "impact",
            "label": "Impact",
            "type": "number",
            "isPrimary": false
          },
          {
            "id": "effort",
            "field": "effort",
            "label": "Effort",
            "type": "number",
            "isPrimary": false
          },
          {
            "id": "roi",
            "field": "roi",
            "label": "ROI",
            "type": "number",
            "isPrimary": false
          }
        ]
      },
      "detail": {
        "sections": [
          {
            "id": "work_item_detail-main",
            "label": "Work Item Detail",
            "fields": [
              {
                "field": "project",
                "label": "Project",
                "emphasize": false
              },
              {
                "field": "title",
                "label": "Title",
                "emphasize": false
              },
              {
                "field": "templateId",
                "label": "TemplateId",
                "emphasize": false
              },
              {
                "field": "description",
                "label": "Description",
                "emphasize": false
              },
              {
                "field": "status",
                "label": "Status",
                "emphasize": false
              },
              {
                "field": "impact",
                "label": "Impact",
                "emphasize": false
              },
              {
                "field": "effort",
                "label": "Effort",
                "emphasize": false
              },
              {
                "field": "roi",
                "label": "Roi",
                "emphasize": false
              },
              {
                "field": "dependencies",
                "label": "Dependencies",
                "emphasize": false
              },
              {
                "field": "owner",
                "label": "Owner",
                "emphasize": false
              },
              {
                "field": "dueDate",
                "label": "DueDate",
                "emphasize": false
              },
              {
                "field": "createdAt",
                "label": "CreatedAt",
                "emphasize": false
              },
              {
                "field": "updatedAt",
                "label": "UpdatedAt",
                "emphasize": false
              }
            ]
          }
        ]
      },
      "form": {
        "entity": "WorkItem",
        "create": {
          "title": "Create WorkItem",
          "sections": [
            {
              "id": "WorkItem-main",
              "title": "WorkItem fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "templateId",
                  "label": "TemplateId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "impact",
                  "label": "Impact",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "effort",
                  "label": "Effort",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "roi",
                  "label": "Roi",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "not_requested",
                      "label": "Not Requested"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "not_planned",
                      "label": "Not Planned"
                    },
                    {
                      "value": "planned",
                      "label": "Planned"
                    },
                    {
                      "value": "in_progress",
                      "label": "In Progress"
                    },
                    {
                      "value": "blocked",
                      "label": "Blocked"
                    },
                    {
                      "value": "completed",
                      "label": "Completed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "dropped",
                      "label": "Dropped"
                    }
                  ]
                },
                {
                  "field": "dependencies",
                  "label": "Dependencies",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "owner",
                  "label": "Owner",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "linkedRequirementIds",
                  "label": "LinkedRequirementIds",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "dueDate",
                  "label": "DueDate",
                  "editor": "date",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit WorkItem",
          "sections": [
            {
              "id": "WorkItem-main",
              "title": "WorkItem fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "templateId",
                  "label": "TemplateId",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "impact",
                  "label": "Impact",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "effort",
                  "label": "Effort",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "roi",
                  "label": "Roi",
                  "editor": "number",
                  "required": false,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "not_requested",
                      "label": "Not Requested"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "not_planned",
                      "label": "Not Planned"
                    },
                    {
                      "value": "planned",
                      "label": "Planned"
                    },
                    {
                      "value": "in_progress",
                      "label": "In Progress"
                    },
                    {
                      "value": "blocked",
                      "label": "Blocked"
                    },
                    {
                      "value": "completed",
                      "label": "Completed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "dropped",
                      "label": "Dropped"
                    }
                  ]
                },
                {
                  "field": "dependencies",
                  "label": "Dependencies",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "owner",
                  "label": "Owner",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "linkedRequirementIds",
                  "label": "LinkedRequirementIds",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "dueDate",
                  "label": "DueDate",
                  "editor": "date",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "checklist-item",
      "entityName": "ChecklistItem",
      "label": "ChecklistItem",
      "list": {
        "columns": [
          {
            "id": "title",
            "field": "title",
            "label": "Title",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "project",
            "field": "project",
            "label": "Project",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "status",
            "field": "status",
            "label": "Status",
            "type": "enum",
            "isPrimary": false
          },
          {
            "id": "owner",
            "field": "owner",
            "label": "Owner",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "dueDate",
            "field": "dueDate",
            "label": "Due Date",
            "type": "date",
            "isPrimary": false
          }
        ]
      },
      "detail": {
        "sections": [
          {
            "id": "checklist_item_detail-main",
            "label": "Checklist Item Detail",
            "fields": [
              {
                "field": "project",
                "label": "Project",
                "emphasize": false
              },
              {
                "field": "title",
                "label": "Title",
                "emphasize": false
              },
              {
                "field": "description",
                "label": "Description",
                "emphasize": false
              },
              {
                "field": "status",
                "label": "Status",
                "emphasize": false
              },
              {
                "field": "owner",
                "label": "Owner",
                "emphasize": false
              },
              {
                "field": "dueDate",
                "label": "DueDate",
                "emphasize": false
              },
              {
                "field": "createdAt",
                "label": "CreatedAt",
                "emphasize": false
              },
              {
                "field": "updatedAt",
                "label": "UpdatedAt",
                "emphasize": false
              }
            ]
          }
        ]
      },
      "form": {
        "entity": "ChecklistItem",
        "create": {
          "title": "Create ChecklistItem",
          "sections": [
            {
              "id": "ChecklistItem-main",
              "title": "ChecklistItem fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "not_requested",
                      "label": "Not Requested"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "not_planned",
                      "label": "Not Planned"
                    },
                    {
                      "value": "planned",
                      "label": "Planned"
                    },
                    {
                      "value": "in_progress",
                      "label": "In Progress"
                    },
                    {
                      "value": "blocked",
                      "label": "Blocked"
                    },
                    {
                      "value": "completed",
                      "label": "Completed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "dropped",
                      "label": "Dropped"
                    }
                  ]
                },
                {
                  "field": "owner",
                  "label": "Owner",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "dueDate",
                  "label": "DueDate",
                  "editor": "date",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit ChecklistItem",
          "sections": [
            {
              "id": "ChecklistItem-main",
              "title": "ChecklistItem fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "description",
                  "label": "Description",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "not_requested",
                      "label": "Not Requested"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "not_planned",
                      "label": "Not Planned"
                    },
                    {
                      "value": "planned",
                      "label": "Planned"
                    },
                    {
                      "value": "in_progress",
                      "label": "In Progress"
                    },
                    {
                      "value": "blocked",
                      "label": "Blocked"
                    },
                    {
                      "value": "completed",
                      "label": "Completed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "dropped",
                      "label": "Dropped"
                    }
                  ]
                },
                {
                  "field": "owner",
                  "label": "Owner",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "dueDate",
                  "label": "DueDate",
                  "editor": "date",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    },
    {
      "id": "project-meeting",
      "entityName": "ProjectMeeting",
      "label": "ProjectMeeting",
      "list": {
        "columns": [
          {
            "id": "title",
            "field": "title",
            "label": "Title",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "project",
            "field": "project",
            "label": "Project",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "templateKey",
            "field": "templateKey",
            "label": "Template",
            "type": "text",
            "isPrimary": false
          },
          {
            "id": "status",
            "field": "status",
            "label": "Status",
            "type": "enum",
            "isPrimary": false
          }
        ]
      },
      "detail": {
        "sections": [
          {
            "id": "project_meeting_detail-main",
            "label": "Project Meeting Detail",
            "fields": [
              {
                "field": "project",
                "label": "Project",
                "emphasize": false
              },
              {
                "field": "title",
                "label": "Title",
                "emphasize": false
              },
              {
                "field": "templateKey",
                "label": "TemplateKey",
                "emphasize": false
              },
              {
                "field": "status",
                "label": "Status",
                "emphasize": false
              },
              {
                "field": "questionsAndAnswers",
                "label": "QuestionsAndAnswers",
                "emphasize": false
              },
              {
                "field": "relatedWorkItemIds",
                "label": "RelatedWorkItemIds",
                "emphasize": false
              },
              {
                "field": "relatedRequirementIds",
                "label": "RelatedRequirementIds",
                "emphasize": false
              },
              {
                "field": "createdAt",
                "label": "CreatedAt",
                "emphasize": false
              },
              {
                "field": "updatedAt",
                "label": "UpdatedAt",
                "emphasize": false
              }
            ]
          }
        ]
      },
      "form": {
        "entity": "ProjectMeeting",
        "create": {
          "title": "Create ProjectMeeting",
          "sections": [
            {
              "id": "ProjectMeeting-main",
              "title": "ProjectMeeting fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "templateKey",
                  "label": "TemplateKey",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "not_requested",
                      "label": "Not Requested"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "not_planned",
                      "label": "Not Planned"
                    },
                    {
                      "value": "planned",
                      "label": "Planned"
                    },
                    {
                      "value": "in_progress",
                      "label": "In Progress"
                    },
                    {
                      "value": "blocked",
                      "label": "Blocked"
                    },
                    {
                      "value": "completed",
                      "label": "Completed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "dropped",
                      "label": "Dropped"
                    }
                  ]
                },
                {
                  "field": "questionsAndAnswers",
                  "label": "QuestionsAndAnswers",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "relatedWorkItemIds",
                  "label": "RelatedWorkItemIds",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "relatedRequirementIds",
                  "label": "RelatedRequirementIds",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        },
        "edit": {
          "title": "Edit ProjectMeeting",
          "sections": [
            {
              "id": "ProjectMeeting-main",
              "title": "ProjectMeeting fields",
              "fields": [
                {
                  "field": "tenant",
                  "label": "Tenant",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "tenantId",
                  "label": "TenantId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "project",
                  "label": "Project",
                  "editor": "select",
                  "required": true,
                  "options": []
                },
                {
                  "field": "projectId",
                  "label": "ProjectId",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "title",
                  "label": "Title",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "templateKey",
                  "label": "TemplateKey",
                  "editor": "text",
                  "required": true,
                  "options": []
                },
                {
                  "field": "status",
                  "label": "Status",
                  "editor": "select",
                  "required": true,
                  "options": [
                    {
                      "value": "not_requested",
                      "label": "Not Requested"
                    },
                    {
                      "value": "pending",
                      "label": "Pending"
                    },
                    {
                      "value": "not_planned",
                      "label": "Not Planned"
                    },
                    {
                      "value": "planned",
                      "label": "Planned"
                    },
                    {
                      "value": "in_progress",
                      "label": "In Progress"
                    },
                    {
                      "value": "blocked",
                      "label": "Blocked"
                    },
                    {
                      "value": "completed",
                      "label": "Completed"
                    },
                    {
                      "value": "done",
                      "label": "Done"
                    },
                    {
                      "value": "failed",
                      "label": "Failed"
                    },
                    {
                      "value": "dropped",
                      "label": "Dropped"
                    }
                  ]
                },
                {
                  "field": "questionsAndAnswers",
                  "label": "QuestionsAndAnswers",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "relatedWorkItemIds",
                  "label": "RelatedWorkItemIds",
                  "editor": "text",
                  "required": false,
                  "options": []
                },
                {
                  "field": "relatedRequirementIds",
                  "label": "RelatedRequirementIds",
                  "editor": "text",
                  "required": false,
                  "options": []
                }
              ]
            }
          ]
        }
      }
    }
  ],
  "screens": [
    {
      "id": "customers_list",
      "type": "list",
      "entity": "Customer",
      "title": "Customers",
      "description": "Manage customer accounts",
      "columns": [
        {
          "id": "name",
          "field": "name",
          "label": "Name",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "code",
          "field": "code",
          "label": "Code",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "sector",
          "field": "sector",
          "label": "Sector",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "countryCode",
          "field": "countryCode",
          "label": "Country",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "contextGenerationStatus",
          "field": "contextGenerationStatus",
          "label": "Context Status",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "createdAt",
          "field": "createdAt",
          "label": "Created",
          "type": "date",
          "isPrimary": false
        }
      ],
      "route": "/customers_list"
    },
    {
      "id": "customer_detail",
      "type": "detail",
      "entity": "Customer",
      "title": "Customer Detail",
      "sections": [
        {
          "id": "customer_detail-main",
          "label": "Customer Detail",
          "fields": [
            {
              "field": "name",
              "label": "Name",
              "emphasize": false
            },
            {
              "field": "code",
              "label": "Code",
              "emphasize": false
            },
            {
              "field": "sector",
              "label": "Sector",
              "emphasize": false
            },
            {
              "field": "countryCode",
              "label": "CountryCode",
              "emphasize": false
            },
            {
              "field": "context",
              "label": "Context",
              "emphasize": false
            },
            {
              "field": "contextSources",
              "label": "ContextSources",
              "emphasize": false
            },
            {
              "field": "contextGeneratedAt",
              "label": "ContextGeneratedAt",
              "emphasize": false
            },
            {
              "field": "contextGeneratedBy",
              "label": "ContextGeneratedBy",
              "emphasize": false
            },
            {
              "field": "contextGenerationStatus",
              "label": "ContextGenerationStatus",
              "emphasize": false
            },
            {
              "field": "contextGenerationError",
              "label": "ContextGenerationError",
              "emphasize": false
            },
            {
              "field": "projects",
              "label": "Projects",
              "emphasize": false
            },
            {
              "field": "createdAt",
              "label": "CreatedAt",
              "emphasize": false
            },
            {
              "field": "updatedAt",
              "label": "UpdatedAt",
              "emphasize": false
            }
          ]
        }
      ],
      "route": "/customer_detail"
    },
    {
      "id": "projects_list",
      "type": "list",
      "entity": "Project",
      "title": "Projects",
      "description": "Track projects by customer",
      "columns": [
        {
          "id": "name",
          "field": "name",
          "label": "Name",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "code",
          "field": "code",
          "label": "Code",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "customer",
          "field": "customer",
          "label": "Customer",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "status",
          "field": "status",
          "label": "Status",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "startDate",
          "field": "startDate",
          "label": "Start Date",
          "type": "date",
          "isPrimary": false
        },
        {
          "id": "endDate",
          "field": "endDate",
          "label": "End Date",
          "type": "date",
          "isPrimary": false
        }
      ],
      "filters": [
        {
          "field": "status"
        }
      ],
      "route": "/projects_list"
    },
    {
      "id": "project_detail",
      "type": "detail",
      "entity": "Project",
      "title": "Project Detail",
      "sections": [
        {
          "id": "project_detail-main",
          "label": "Project Detail",
          "fields": [
            {
              "field": "customer",
              "label": "Customer",
              "emphasize": false
            },
            {
              "field": "name",
              "label": "Name",
              "emphasize": false
            },
            {
              "field": "code",
              "label": "Code",
              "emphasize": false
            },
            {
              "field": "status",
              "label": "Status",
              "emphasize": false
            },
            {
              "field": "startDate",
              "label": "StartDate",
              "emphasize": false
            },
            {
              "field": "endDate",
              "label": "EndDate",
              "emphasize": false
            },
            {
              "field": "requirements",
              "label": "Requirements",
              "emphasize": false
            },
            {
              "field": "workItems",
              "label": "WorkItems",
              "emphasize": false
            },
            {
              "field": "specSections",
              "label": "SpecSections",
              "emphasize": false
            },
            {
              "field": "meetings",
              "label": "Meetings",
              "emphasize": false
            },
            {
              "field": "createdAt",
              "label": "CreatedAt",
              "emphasize": false
            },
            {
              "field": "updatedAt",
              "label": "UpdatedAt",
              "emphasize": false
            }
          ]
        }
      ],
      "route": "/project_detail"
    },
    {
      "id": "requirements_list",
      "type": "list",
      "entity": "Requirement",
      "title": "Requirements",
      "description": "Review and track requirements",
      "columns": [
        {
          "id": "title",
          "field": "title",
          "label": "Title",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "project",
          "field": "project",
          "label": "Project",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "reviewStatus",
          "field": "reviewStatus",
          "label": "Review Status",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "aiReviewStatus",
          "field": "aiReviewStatus",
          "label": "AI Review Status",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "generationRequested",
          "field": "generationRequested",
          "label": "Generation Requested",
          "type": "badge",
          "isPrimary": false
        },
        {
          "id": "generationStatus",
          "field": "generationStatus",
          "label": "Generation Status",
          "type": "enum",
          "isPrimary": false
        }
      ],
      "filters": [
        {
          "field": "reviewStatus"
        },
        {
          "field": "aiReviewStatus"
        },
        {
          "field": "generationRequested"
        }
      ],
      "route": "/requirements_list"
    },
    {
      "id": "requirements_to_review_list",
      "type": "list",
      "entity": "Requirement",
      "title": "Requirements to Review",
      "description": "Requirements awaiting review approval",
      "columns": [
        {
          "id": "title",
          "field": "title",
          "label": "Title",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "project",
          "field": "project",
          "label": "Project",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "reviewStatus",
          "field": "reviewStatus",
          "label": "Review Status",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "generationStatus",
          "field": "generationStatus",
          "label": "Generation Status",
          "type": "enum",
          "isPrimary": false
        }
      ],
      "filters": [
        {
          "field": "reviewStatus",
          "defaultValue": "pending_review"
        }
      ],
      "defaultFilters": {
        "reviewStatus": "pending_review"
      },
      "route": "/requirements_to_review_list"
    },
    {
      "id": "requirements_to_generate_list",
      "type": "list",
      "entity": "Requirement",
      "title": "Requirements to Generate",
      "description": "Requirements where generation has been requested",
      "columns": [
        {
          "id": "title",
          "field": "title",
          "label": "Title",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "project",
          "field": "project",
          "label": "Project",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "generationRequested",
          "field": "generationRequested",
          "label": "Generation Requested",
          "type": "badge",
          "isPrimary": false
        },
        {
          "id": "generationStatus",
          "field": "generationStatus",
          "label": "Generation Status",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "generationTarget",
          "field": "generationTarget",
          "label": "Generation Target",
          "type": "enum",
          "isPrimary": false
        }
      ],
      "filters": [
        {
          "field": "generationRequested",
          "defaultValue": true
        }
      ],
      "defaultFilters": {
        "generationRequested": true
      },
      "route": "/requirements_to_generate_list"
    },
    {
      "id": "requirement_detail",
      "type": "detail",
      "entity": "Requirement",
      "title": "Requirement Detail",
      "sections": [
        {
          "id": "requirement_detail-main",
          "label": "Requirement Detail",
          "fields": [
            {
              "field": "project",
              "label": "Project",
              "emphasize": false
            },
            {
              "field": "title",
              "label": "Title",
              "emphasize": false
            },
            {
              "field": "description",
              "label": "Description",
              "emphasize": false
            },
            {
              "field": "sourceType",
              "label": "SourceType",
              "emphasize": false
            },
            {
              "field": "sourceMeetingId",
              "label": "SourceMeetingId",
              "emphasize": false
            },
            {
              "field": "sourceMeetingQuestionId",
              "label": "SourceMeetingQuestionId",
              "emphasize": false
            },
            {
              "field": "sourceDraftKey",
              "label": "SourceDraftKey",
              "emphasize": false
            },
            {
              "field": "sourceFileName",
              "label": "SourceFileName",
              "emphasize": false
            },
            {
              "field": "reviewStatus",
              "label": "ReviewStatus",
              "emphasize": false
            },
            {
              "field": "aiReviewStatus",
              "label": "AiReviewStatus",
              "emphasize": false
            },
            {
              "field": "generationRequested",
              "label": "GenerationRequested",
              "emphasize": false
            },
            {
              "field": "generationStatus",
              "label": "GenerationStatus",
              "emphasize": false
            },
            {
              "field": "generationTarget",
              "label": "GenerationTarget",
              "emphasize": false
            },
            {
              "field": "generatedSummary",
              "label": "GeneratedSummary",
              "emphasize": false
            },
            {
              "field": "generatedArtifacts",
              "label": "GeneratedArtifacts",
              "emphasize": false
            },
            {
              "field": "createdAt",
              "label": "CreatedAt",
              "emphasize": false
            },
            {
              "field": "updatedAt",
              "label": "UpdatedAt",
              "emphasize": false
            }
          ]
        }
      ],
      "route": "/requirement_detail"
    },
    {
      "id": "spec_sections_list",
      "type": "list",
      "entity": "SpecSection",
      "title": "Spec Sections",
      "description": "Structured sections extracted from spec sources",
      "columns": [
        {
          "id": "title",
          "field": "title",
          "label": "Title",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "specSource",
          "field": "specSource",
          "label": "Source",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "project",
          "field": "project",
          "label": "Project",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "dslKind",
          "field": "dslKind",
          "label": "DSL Kind",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "reviewStatus",
          "field": "reviewStatus",
          "label": "Review Status",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "aiReviewStatus",
          "field": "aiReviewStatus",
          "label": "AI Review Status",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "dslStatus",
          "field": "dslStatus",
          "label": "DSL Status",
          "type": "enum",
          "isPrimary": false
        }
      ],
      "filters": [
        {
          "field": "dslKind"
        },
        {
          "field": "reviewStatus"
        },
        {
          "field": "aiReviewStatus"
        },
        {
          "field": "dslStatus"
        }
      ],
      "route": "/spec_sections_list"
    },
    {
      "id": "spec_section_detail",
      "type": "detail",
      "entity": "SpecSection",
      "title": "Spec Section Overview",
      "sections": [
        {
          "id": "spec_section_detail-main",
          "label": "Spec Section Overview",
          "fields": [
            {
              "field": "project",
              "label": "Project",
              "emphasize": false
            },
            {
              "field": "specSource",
              "label": "SpecSource",
              "emphasize": false
            },
            {
              "field": "title",
              "label": "Title",
              "emphasize": false
            },
            {
              "field": "category",
              "label": "Category",
              "emphasize": false
            },
            {
              "field": "kind",
              "label": "Kind",
              "emphasize": false
            },
            {
              "field": "dslKind",
              "label": "DslKind",
              "emphasize": false
            },
            {
              "field": "dslStatus",
              "label": "DslStatus",
              "emphasize": false
            },
            {
              "field": "reviewStatus",
              "label": "ReviewStatus",
              "emphasize": false
            },
            {
              "field": "aiReviewStatus",
              "label": "AiReviewStatus",
              "emphasize": false
            },
            {
              "field": "summary",
              "label": "Summary",
              "emphasize": false
            },
            {
              "field": "details",
              "label": "Details",
              "emphasize": false
            },
            {
              "field": "content",
              "label": "Content",
              "emphasize": false
            },
            {
              "field": "level",
              "label": "Level",
              "emphasize": false
            },
            {
              "field": "sequence",
              "label": "Sequence",
              "emphasize": false
            },
            {
              "field": "sourceMeetingId",
              "label": "SourceMeetingId",
              "emphasize": false
            },
            {
              "field": "sourceMeetingQuestionId",
              "label": "SourceMeetingQuestionId",
              "emphasize": false
            },
            {
              "field": "sourceDraftKey",
              "label": "SourceDraftKey",
              "emphasize": false
            },
            {
              "field": "createdAt",
              "label": "CreatedAt",
              "emphasize": false
            },
            {
              "field": "updatedAt",
              "label": "UpdatedAt",
              "emphasize": false
            }
          ]
        }
      ],
      "route": "/spec_section_detail"
    },
    {
      "id": "work_items_list",
      "type": "list",
      "entity": "WorkItem",
      "title": "Work Items",
      "description": "Follow work items linked to the project",
      "columns": [
        {
          "id": "title",
          "field": "title",
          "label": "Title",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "templateId",
          "field": "templateId",
          "label": "Template",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "project",
          "field": "project",
          "label": "Project",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "status",
          "field": "status",
          "label": "Status",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "owner",
          "field": "owner",
          "label": "Owner",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "dueDate",
          "field": "dueDate",
          "label": "Due Date",
          "type": "date",
          "isPrimary": false
        },
        {
          "id": "impact",
          "field": "impact",
          "label": "Impact",
          "type": "number",
          "isPrimary": false
        },
        {
          "id": "effort",
          "field": "effort",
          "label": "Effort",
          "type": "number",
          "isPrimary": false
        },
        {
          "id": "roi",
          "field": "roi",
          "label": "ROI",
          "type": "number",
          "isPrimary": false
        }
      ],
      "filters": [
        {
          "field": "status"
        }
      ],
      "route": "/work_items_list"
    },
    {
      "id": "work_item_detail",
      "type": "detail",
      "entity": "WorkItem",
      "title": "Work Item Detail",
      "sections": [
        {
          "id": "work_item_detail-main",
          "label": "Work Item Detail",
          "fields": [
            {
              "field": "project",
              "label": "Project",
              "emphasize": false
            },
            {
              "field": "title",
              "label": "Title",
              "emphasize": false
            },
            {
              "field": "templateId",
              "label": "TemplateId",
              "emphasize": false
            },
            {
              "field": "description",
              "label": "Description",
              "emphasize": false
            },
            {
              "field": "status",
              "label": "Status",
              "emphasize": false
            },
            {
              "field": "impact",
              "label": "Impact",
              "emphasize": false
            },
            {
              "field": "effort",
              "label": "Effort",
              "emphasize": false
            },
            {
              "field": "roi",
              "label": "Roi",
              "emphasize": false
            },
            {
              "field": "dependencies",
              "label": "Dependencies",
              "emphasize": false
            },
            {
              "field": "owner",
              "label": "Owner",
              "emphasize": false
            },
            {
              "field": "dueDate",
              "label": "DueDate",
              "emphasize": false
            },
            {
              "field": "createdAt",
              "label": "CreatedAt",
              "emphasize": false
            },
            {
              "field": "updatedAt",
              "label": "UpdatedAt",
              "emphasize": false
            }
          ]
        }
      ],
      "route": "/work_item_detail"
    },
    {
      "id": "project_meetings_list",
      "type": "list",
      "entity": "ProjectMeeting",
      "title": "Project Meetings",
      "description": "Manage project meetings and outcomes",
      "columns": [
        {
          "id": "title",
          "field": "title",
          "label": "Title",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "project",
          "field": "project",
          "label": "Project",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "templateKey",
          "field": "templateKey",
          "label": "Template",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "status",
          "field": "status",
          "label": "Status",
          "type": "enum",
          "isPrimary": false
        }
      ],
      "filters": [
        {
          "field": "status"
        }
      ],
      "route": "/project_meetings_list"
    },
    {
      "id": "project_meeting_detail",
      "type": "detail",
      "entity": "ProjectMeeting",
      "title": "Project Meeting Detail",
      "sections": [
        {
          "id": "project_meeting_detail-main",
          "label": "Project Meeting Detail",
          "fields": [
            {
              "field": "project",
              "label": "Project",
              "emphasize": false
            },
            {
              "field": "title",
              "label": "Title",
              "emphasize": false
            },
            {
              "field": "templateKey",
              "label": "TemplateKey",
              "emphasize": false
            },
            {
              "field": "status",
              "label": "Status",
              "emphasize": false
            },
            {
              "field": "questionsAndAnswers",
              "label": "QuestionsAndAnswers",
              "emphasize": false
            },
            {
              "field": "relatedWorkItemIds",
              "label": "RelatedWorkItemIds",
              "emphasize": false
            },
            {
              "field": "relatedRequirementIds",
              "label": "RelatedRequirementIds",
              "emphasize": false
            },
            {
              "field": "createdAt",
              "label": "CreatedAt",
              "emphasize": false
            },
            {
              "field": "updatedAt",
              "label": "UpdatedAt",
              "emphasize": false
            }
          ]
        }
      ],
      "route": "/project_meeting_detail"
    },
    {
      "id": "checklist_items_list",
      "type": "list",
      "entity": "ChecklistItem",
      "title": "Checklist Items",
      "description": "Track project checklist items",
      "columns": [
        {
          "id": "title",
          "field": "title",
          "label": "Title",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "project",
          "field": "project",
          "label": "Project",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "status",
          "field": "status",
          "label": "Status",
          "type": "enum",
          "isPrimary": false
        },
        {
          "id": "owner",
          "field": "owner",
          "label": "Owner",
          "type": "text",
          "isPrimary": false
        },
        {
          "id": "dueDate",
          "field": "dueDate",
          "label": "Due Date",
          "type": "date",
          "isPrimary": false
        }
      ],
      "filters": [
        {
          "field": "status"
        }
      ],
      "route": "/checklist_items_list"
    },
    {
      "id": "checklist_item_detail",
      "type": "detail",
      "entity": "ChecklistItem",
      "title": "Checklist Item Detail",
      "sections": [
        {
          "id": "checklist_item_detail-main",
          "label": "Checklist Item Detail",
          "fields": [
            {
              "field": "project",
              "label": "Project",
              "emphasize": false
            },
            {
              "field": "title",
              "label": "Title",
              "emphasize": false
            },
            {
              "field": "description",
              "label": "Description",
              "emphasize": false
            },
            {
              "field": "status",
              "label": "Status",
              "emphasize": false
            },
            {
              "field": "owner",
              "label": "Owner",
              "emphasize": false
            },
            {
              "field": "dueDate",
              "label": "DueDate",
              "emphasize": false
            },
            {
              "field": "createdAt",
              "label": "CreatedAt",
              "emphasize": false
            },
            {
              "field": "updatedAt",
              "label": "UpdatedAt",
              "emphasize": false
            }
          ]
        }
      ],
      "route": "/checklist_item_detail"
    }
  ]
} as const;

export const projectRequirementsAppSpecV0 = appUiSpec;
